// Chaves partilhadas entre módulos (mantidas com os mesmos nomes usados em
// sge_infantil_web/src/pages/*/locales para facilitar a reutilização).
const pt = {
  'global.next': 'Próximo',
  'global.previous': 'Anterior',
  'global.confirm': 'Confirmar',
  'global.confirm.title': 'Confirmação',
  'global.edit': 'Editar',
  'global.delete': 'Eliminar',
  'global.cancel': 'Cancelar',
  'global.save': 'Guardar',
  'global.close': 'Fechar',
  'global.search': 'Pesquisar',
  'global.refresh': 'Actualizar',
  'global.back': 'Voltar',
  'global.name': 'Nome',
  'global.single': 'Solteiro(a)',
  'global.divorced': 'Divorciado(a)',
  'global.married': 'Casado(a)',
  'global.widower': 'Viúvo(a)',
  'global.middle.school': 'Ensino Médio',
  'global.bachelor': 'Ensino Superior',
  'global.master': 'Mestrado',
  'global.doctor': 'Doutoramento',
  'global.post.graduated': 'Pós-Graduação',
  'global.marital.status': 'Estado Civil',
  'global.birth.date': 'Data de Nascimento',
  'global.birth.day': 'Dia',
  'global.birth.month': 'Mês',
  'global.birth.year': 'Ano',
  'global.contact': 'Contacto',
  'global.email': 'Email',
  'global.educational.level': 'Grau de Formação',
  'global.personal.information': 'Informações Pessoais',
  'global.photo': 'Fotografia',
  'global.success': 'Sucesso',
  'global.status': 'Estado',
  'global.active': 'Activo',
  'global.inactive': 'Inactivo',
  'global.activate': 'Activar',
  'global.deactivate': 'Inactivar',
  'global.gender': 'Género',
  'global.male': 'Masculino',
  'global.female': 'Feminino',
  'global.bi': 'Bilhete de Identidade',
  'global.nuit': 'NUIT',
  'global.degree.year': 'Ano de Conclusão',
  'global.degree.instituition': 'Instituição',
  'global.contract.type': 'Tipo de Contrato',
  'global.contract.position': 'Posição',
  'global.contract.info': 'Informações do Contrato',
  'global.degree.info': 'Informações do Grau',
  'global.register.date': 'Data de Registo',
  'global.col.actions': 'Acções',
  'global.clean.fields': 'Limpar Campos',
  'global.filters': 'Filtros',
  'global.all': 'Todos',
  'global.error.title': 'Erro',
  'global.error.message': 'Ocorreu um erro ao processar o pedido',
  'validation.required': 'Campo obrigatório',
  'validation.bi.invalid': 'BI inválido (mínimo 10 dígitos seguidos de 1 letra maiúscula)',
  'validation.email.invalid': 'Email inválido',

  // Funcionários
  'funcionario.breadcrumb.create': 'Cadastrar Funcionário',
  'funcionario.breadcrumb.list': 'Lista de Funcionários',
  'funcionario.breadcrumb.edit': 'Editar Funcionário',
  'funcionario.wizard.title': 'Cadastrar Novo Funcionário',
  'funcionario.wizard.subtitle': 'Preencha os dados abaixo e avance pelos passos seguintes.',
  'funcionario.wizard.step.personal': 'Dados Pessoais',
  'funcionario.wizard.step.degree': 'Formação',
  'funcionario.wizard.step.contract': 'Contrato',
  'funcionario.wizard.step.confirm': 'Confirmação',
  'funcionario.field.name': 'Nome Completo',
  'funcionario.field.name.placeholder': 'Nome completo do funcionário',
  'funcionario.field.bi': 'Bilhete de Identidade',
  'funcionario.field.bi.placeholder': 'Número do BI',
  'funcionario.field.nuit': 'NUIT',
  'funcionario.field.nuit.placeholder': 'Número Único de Identificação Tributária',
  'funcionario.field.birthDate': 'Data de Nascimento',
  'funcionario.field.maritalStatus': 'Estado Civil',
  'funcionario.field.gender': 'Género',
  'funcionario.field.email': 'Email',
  'funcionario.field.email.placeholder': 'nome@exemplo.com',
  'funcionario.field.contact': 'Contacto',
  'funcionario.field.educationalLevel': 'Grau de Formação',
  'funcionario.field.degreeYear': 'Ano de Conclusão',
  'funcionario.field.degreeYear.placeholder': 'Ex: 2020',
  'funcionario.field.institution': 'Instituição',
  'funcionario.field.institution.placeholder': 'Instituição de ensino',
  'funcionario.field.contractType': 'Tipo de Contrato',
  'funcionario.field.position': 'Posição',
  'funcionario.select.placeholder': 'Seleccione...',
  'funcionario.confirm.description': 'Confirme os dados abaixo antes de submeter.',
  'funcionario.create.success.title': 'Funcionário cadastrado com sucesso',
  'funcionario.create.success.subtitle': 'Os dados foram guardados no sistema.',
  'funcionario.create.new': 'Cadastrar Outro Funcionário',
  'funcionario.error.duplicate': 'Funcionário com o mesmo NUIT já existe.',
  'funcionario.list.title': 'Funcionários',
  'funcionario.list.subtitle': 'Consulte, edite e active/desactive os funcionários da escola.',
  'funcionario.list.search.placeholder': 'Pesquisar por nome, email ou contacto',
  'funcionario.list.add': 'Adicionar Novo Funcionário',
  'funcionario.list.empty': 'Nenhum funcionário encontrado',
  'funcionario.list.loading': 'A carregar...',
  'funcionario.list.total': 'funcionário(s)',
  'funcionario.list.activate': 'Activar',
  'funcionario.list.inactivate': 'Desactivar',
  'funcionario.list.activate.success': 'Funcionário activado com sucesso',
  'funcionario.list.inactivate.success': 'Funcionário desactivado com sucesso',
  'funcionario.list.toggle.error': 'Erro ao alterar o estado do funcionário',
  'funcionario.list.stat.total': 'Total de Funcionários',
  'funcionario.list.stat.active': 'Activos',
  'funcionario.list.stat.inactive': 'Inactivos',
  'funcionario.expand.tab.personal': 'Dados Pessoais',
  'funcionario.expand.tab.degree': 'Formação',
  'funcionario.expand.tab.contract': 'Contrato',
  'funcionario.edit.title': 'Editar Funcionário',
  'funcionario.edit.subtitle': 'Actualize os dados do funcionário e guarde as alterações.',
  'funcionario.edit.success': 'Funcionário actualizado com sucesso',
  'funcionario.edit.not.found': 'Funcionário não encontrado. Volte à lista e tente novamente.',
  'funcionario.edit.back.to.list': 'Voltar à Lista',

  // Professores
  'professor.breadcrumb.create': 'Cadastrar Professor',
  'professor.breadcrumb.list': 'Lista de Professores',
  'professor.breadcrumb.edit': 'Editar Professor',
  'professor.wizard.title': 'Cadastrar Novo Professor',
  'professor.wizard.subtitle': 'Preencha os dados abaixo e avance pelos passos seguintes.',
  'professor.wizard.step.info': 'Dados do Professor',
  'professor.wizard.step.confirm': 'Confirmação',
  'professor.wizard.step.success': 'Sucesso',
  'professor.field.name': 'Nome Completo',
  'professor.field.name.placeholder': 'Nome completo do professor',
  'professor.field.email': 'Email',
  'professor.field.email.placeholder': 'nome@exemplo.com',
  'professor.field.contact': 'Contacto',
  'professor.field.birthDate': 'Data de Nascimento',
  'professor.field.birthDay': 'Dia',
  'professor.field.birthMonth': 'Mês',
  'professor.field.birthYear': 'Ano',
  'professor.field.maritalStatus': 'Estado Civil',
  'professor.field.educationalLevel': 'Grau de Formação',
  'professor.field.subjects': 'Disciplinas que lecciona',
  'professor.field.subjects.empty': 'Sem disciplinas disponíveis',
  'professor.select.placeholder': 'Seleccione...',
  'professor.confirm.description': 'Confirme os dados abaixo antes de submeter.',
  'professor.create.success.title': 'Professor cadastrado com sucesso',
  'professor.create.success.subtitle': 'Os dados foram guardados no sistema.',
  'professor.create.new': 'Cadastrar Outro Professor',
  'professor.list.title': 'Professores',
  'professor.list.subtitle': 'Consulte, edite e remova os professores da escola.',
  'professor.list.search.placeholder': 'Pesquisar por nome, email ou contacto',
  'professor.list.add': 'Adicionar Novo Professor',
  'professor.list.empty': 'Nenhum professor encontrado',
  'professor.list.loading': 'A carregar...',
  'professor.list.total': 'professor(es)',
  'professor.list.stat.total': 'Total de Professores',
  'professor.list.stat.withSubjects': 'Com Disciplinas Atribuídas',
  'professor.expand.tab.personal': 'Dados Pessoais',
  'professor.expand.tab.academic': 'Formação Académica',
  'professor.list.remove': 'Remover',
  'professor.list.remove.confirm': 'Tem a certeza que deseja remover este professor?',
  'professor.list.remove.success': 'Professor removido com sucesso',
  'professor.list.remove.error': 'Erro ao remover professor',
  'professor.edit.title': 'Editar Professor',
  'professor.edit.subtitle': 'Actualize os dados do professor e guarde as alterações.',
  'professor.edit.success': 'Professor actualizado com sucesso',
  'professor.edit.not.found': 'Professor não encontrado. Volte à lista e tente novamente.',
  'professor.edit.back.to.list': 'Voltar à Lista',

  // Estudantes
  'estudante.breadcrumb.create': 'Cadastrar Estudante',
  'estudante.breadcrumb.list': 'Lista de Estudantes Activos',
  'estudante.breadcrumb.edit': 'Editar Estudante',
  'estudante.wizard.title': 'Cadastrar Novo Estudante',
  'estudante.wizard.subtitle': 'Preencha os dados abaixo e avance pelos passos seguintes.',
  'estudante.wizard.step.personal': 'Dados Pessoais',
  'estudante.personal.subtitle': 'Preencha os dados de identificação, morada e saúde do estudante.',
  'estudante.personal.identification.title': 'Identificação',
  'estudante.personal.address.title': 'Morada e Saúde',
  'estudante.field.photo': 'Fotografia do Estudante',
  'estudante.field.photo.placeholder': 'Adicionar Foto',
  'estudante.photo.takePhoto': 'Tirar Foto',
  'estudante.photo.uploadPhoto': 'Carregar Foto',
  'estudante.photo.capture': 'Capturar',
  'estudante.photo.uploading': 'A carregar fotografia...',
  'estudante.error.camera': 'Não foi possível aceder à câmara.',
  'estudante.wizard.step.parents': 'Filiação',
  'estudante.wizard.step.sponsor': 'Encarregado',
  'estudante.wizard.step.registration': 'Inscrição',
  'estudante.wizard.step.confirm': 'Confirmar',
  'estudante.field.name': 'Nome Completo',
  'estudante.field.name.placeholder': 'Nome completo do estudante',
  'estudante.field.code': 'Código',
  'estudante.field.code.placeholder': 'Código único do estudante (opcional)',
  'estudante.field.birthDate': 'Data de Nascimento',
  'estudante.field.gender': 'Sexo',
  'estudante.field.docType': 'Tipo de Documento',
  'estudante.field.docNumber': 'Número do Documento',
  'estudante.field.address': 'Morada',
  'estudante.field.hasDesease': 'Tem alguma doença?',
  'estudante.field.deseaseDesc': 'Descrição da Doença',
  'estudante.field.isNew': 'É novo ingresso?',
  'estudante.field.enrollmentYear': 'Ano de Ingresso',
  'estudante.field.isAlergicToFood': 'É alérgico a alimentos?',
  'estudante.field.alergicToFood': 'Descrição da Alergia Alimentar',
  'estudante.field.isAlergicToMedicine': 'É alérgico a medicamentos?',
  'estudante.field.alergicToMedicine': 'Descrição da Alergia a Medicamentos',
  'estudante.field.fatherName': 'Nome do Pai',
  'estudante.field.motherName': 'Nome da Mãe',
  'estudante.field.fatherContact': 'Contacto do Pai',
  'estudante.field.motherContact': 'Contacto da Mãe',
  'estudante.field.kinshipDegree': 'Grau de Parentesco',
  'estudante.field.carierName': 'Nome do Encarregado',
  'estudante.field.jobLocation': 'Local de Trabalho',
  'estudante.field.carierContact': 'Contacto do Encarregado',
  'estudante.field.secondCarierContact': 'Número do Encarregado Alternativo',
  'estudante.field.contact': 'Contacto',
  'estudante.expand.tab.personal': 'Dados Pessoais',
  'estudante.expand.tab.family': 'Encarregado',
  'estudante.expand.tab.enrollment': 'Inscrição',
  'estudante.expand.turma': 'Turma',
  'estudante.expand.year': 'Ano Lectivo',
  'estudante.expand.paymentMethod': 'Método de Pagamento',
  'estudante.expand.scheduleType': 'Horário',
  'estudante.field.carierAddress': 'Morada do Encarregado',
  'estudante.field.selectedYear': 'Ano Lectivo',
  'estudante.field.frequency.curso': 'Turma/Curso',
  'estudante.field.frequency.classe': 'Turma/Classe',
  'estudante.field.frequency.nivel': 'Turma/Nível',
  'estudante.field.extraActivities': 'Actividades Extra-Curriculares',
  'estudante.field.paymentMethod': 'Forma de Pagamento',
  'estudante.field.scheduleType': 'Horário',
  'estudante.field.scheduleType.standard': '7h - 12h',
  'estudante.field.scheduleType.special': '7h - 15h',
  'estudante.field.scholarshipType': 'Tipo de Bolsa/Desconto',
  'estudante.field.registrationValue': 'Valor de Inscrição',
  'estudante.field.monthlyPayment': 'Propina Mensal',
  'estudante.select.placeholder': 'Seleccione...',
  'estudante.confirm.description': 'Confirme os dados abaixo antes de submeter.',
  'estudante.create.success.title': 'Estudante cadastrado com sucesso',
  'estudante.create.success.subtitle': 'A matrícula foi registada no sistema.',
  'estudante.create.new': 'Cadastrar Outro Estudante',
  'estudante.list.title': 'Estudantes Activos',
  'estudante.list.subtitle': 'Consulte, edite e faça a gestão dos estudantes activos da escola.',
  'estudante.list.search.placeholder': 'Pesquisar por nome ou código',
  'estudante.list.add': 'Adicionar Novo Estudante',
  'estudante.list.empty': 'Nenhum estudante encontrado',
  'estudante.list.loading': 'A carregar...',
  'estudante.list.total': 'estudante(s)',
  'estudante.list.filter.year': 'Ano Lectivo',
  'estudante.list.filter.sex': 'Sexo',
  'estudante.list.filter.turma': 'Turma',
  'estudante.list.filter.all': 'Todos',
  'estudante.list.filter.clear': 'Limpar Filtros',
  'estudante.list.action.edit': 'Editar',
  'estudante.list.action.inactivate': 'Inactivar',
  'estudante.list.action.remove': 'Remover',
  'estudante.list.action.print.enrollment': 'Comprovativo de Cadastro',
  'estudante.list.action.print.profile': 'Ficha de Estudante',
  'estudante.list.action.notify': 'Notificar',
  'estudante.list.action.notifyAll': 'Notificar a Todos',
  'estudante.list.action.addExtra': 'Adicionar Extra',
  'estudante.list.action.removeExtra': 'Remover Extra',
  'estudante.list.action.allocateTurma': 'Alocar Turma',
  'estudante.allocateTurma.tab.select': 'Turma Existente',
  'estudante.allocateTurma.tab.create': 'Criar Nova Turma',
  'estudante.allocateTurma.select.placeholder': 'Seleccione a turma...',
  'estudante.allocateTurma.select.empty': 'Não existem turmas criadas para esta classe.',
  'estudante.allocateTurma.select.alreadyAllocated': 'Este estudante já está alocado à turma',
  'estudante.allocateTurma.success': 'Estudante alocado à turma com sucesso.',
  'estudante.allocateTurma.error': 'Não foi possível alocar o estudante à turma.',
  'estudante.list.selected.count': '{count} seleccionado(s)',
  'estudante.list.selected.clear': 'Limpar selecção',
  'estudante.list.confirm.inactivate.title': 'Inactivar Estudante',
  'estudante.list.confirm.inactivate.reason': 'Motivo da Inactivação',
  'estudante.list.confirm.remove.title': 'Remover Estudante',
  'estudante.list.confirm.remove.message': 'Esta acção é irreversível. Tem a certeza que deseja remover este estudante?',
  'estudante.list.inactivate.success': 'Estudante inactivado com sucesso',
  'estudante.list.remove.success': 'Estudante removido com sucesso',
  'estudante.list.action.error': 'Erro ao processar o pedido',
  'estudante.list.print.error': 'Erro ao gerar o documento',
  'estudante.list.notify.title': 'Notificar Encarregado',
  'estudante.list.notify.type': 'Tipo de Notificação',
  'estudante.list.notify.type.comunicado': 'Comunicado',
  'estudante.list.notify.type.convocatoria': 'Convocatória',
  'estudante.list.notify.message': 'Mensagem',
  'estudante.list.notify.send': 'Enviar',
  'estudante.list.notify.success': 'Notificação enviada com sucesso',
  'estudante.list.notify.error': 'Erro ao enviar a notificação',
  'estudante.edit.title': 'Editar Estudante',
  'estudante.edit.subtitle': 'Actualize os dados do estudante e guarde as alterações.',
  'estudante.edit.tab.documents': 'Documentos',
  'estudante.edit.tab.documents.photoHint':
    'Para actualizar a fotografia, utilize o botão junto à foto do estudante, à esquerda.',
  'estudante.edit.success': 'Estudante actualizado com sucesso',
  'estudante.edit.not.found': 'Estudante não encontrado. Volte à lista e tente novamente.',
  'estudante.edit.back.to.list': 'Voltar à Lista',

  // Estudantes — chaves adicionais usadas pelos componentes (wizard de 6
  // passos, lista modernizada com dropdown de acções e página de edição).
  'global.no': 'Não',
  'global.yes': 'Sim',
  'estudante.wizard.step.filiation': 'Filiação',
  'estudante.wizard.step.guardian': 'Encarregado',
  'estudante.filiation.subtitle': 'Indique os dados dos pais do estudante.',
  'estudante.guardian.subtitle': 'Indique quem é o encarregado de educação responsável pelo estudante.',
  'estudante.wizard.step.enrollment': 'Inscrição',
  'estudante.wizard.step.success': 'Sucesso',
  'estudante.error.photo.upload': 'Erro ao enviar a fotografia',
  'estudante.docType.bi': 'Bilhete de Identidade',
  'estudante.docType.passport': 'Passaporte',
  'estudante.docType.cedula': 'Cédula Pessoal',
  'estudante.docType.bolentim': 'Boletim de Nascimento',
  'estudante.docType.none': 'Nenhum',
  'estudante.field.studentAddress': 'Morada do Estudante',
  'estudante.field.studentAddress.placeholder': 'Endereço completo do estudante',
  'estudante.kinship.father': 'Pai',
  'estudante.kinship.mother': 'Mãe',
  'estudante.kinship.uncle': 'Tio(a)',
  'estudante.kinship.grandparent': 'Avô/Avó',
  'estudante.kinship.sibling': 'Irmão/Irmã',
  'estudante.paymentMethod.cash': 'Numerário',
  'estudante.paymentMethod.pos': 'POS',
  'estudante.paymentMethod.transfer': 'Transferência Bancária',
  'estudante.paymentMethod.deposit': 'Depósito Bancário',
  'estudante.paymentMethod.mpesa': 'M-Pesa',
  'estudante.paymentMethod.emola': 'E-Mola',
  'estudante.field.extraCuricularActivities': 'Actividades Extra-Curriculares',
  'estudante.field.extraCuricularActivities.hint':
    'Clique para abrir a lista e seleccione uma ou mais actividades.',
  'estudante.field.extraCuricularActivities.empty': 'Nenhuma actividade disponível',
  'estudante.enrollment.details.title': 'Detalhes da Inscrição',
  'estudante.enrollment.details.subtitle':
    'Escolha a turma do estudante e registe o pagamento da taxa de Inscrição.',
  'estudante.scholarship.title': 'Situação Académica do Estudante',
  'estudante.scholarship.type': 'O estudante é bolseiro?',
  'estudante.scholarship.type.none': 'Não (Estudante Regular)',
  'estudante.scholarship.type.discount': 'Não, mas tem Desconto Regular',
  'estudante.scholarship.type.partial': 'Sim - Bolseiro Parcial',
  'estudante.scholarship.type.full': 'Sim - Bolseiro Completo (100%)',
  'estudante.scholarship.full.info':
    'As mensalidades deste estudante estão 100% isentas. Configure abaixo os detalhes da inscrição.',
  'estudante.scholarship.exemptRegistration': 'Isentar também o pagamento da inscrição (100%)',
  'estudante.scholarship.registrationDiscount': 'Desconto na Inscrição',
  'estudante.discount.type': 'Tipo de Desconto',
  'estudante.discount.type.percentage': 'Percentual (%)',
  'estudante.discount.type.numeric': 'Valor Fixo (MZN)',
  'estudante.discount.appliesTo': 'Aplicar Desconto em',
  'estudante.discount.appliesTo.registration': 'Apenas Inscrição',
  'estudante.discount.appliesTo.payment': 'Apenas Mensalidade',
  'estudante.discount.appliesTo.both': 'Ambos (Inscrição e Mensalidade)',
  'estudante.discount.registration': 'Desconto na Inscrição',
  'estudante.discount.monthly': 'Desconto na Mensalidade',
  'estudante.discount.value': 'Valor do Desconto',
  'estudante.summary.registrationValue': 'Valor de Inscrição',
  'estudante.summary.monthlyPayment': 'Mensalidade',
  'estudante.summary.total': 'Total a Pagar',
  'estudante.registrationPayment.title': 'Pagamento da Inscrição',
  'estudante.registrationPayment.subtitle':
    'Defina o desconto, a bolsa e o método de pagamento da taxa de Inscrição. Esta secção não inclui a mensalidade.',
  'estudante.registrationPayment.amountDue': 'Valor da Inscrição',
  'estudante.registrationPayment.amountPaid': 'Valor Pago',
  'estudante.registrationPayment.remaining': 'Valor Remanescente',
  'estudante.validation.registrationAmountPaid': 'Indique um valor pago válido para a Inscrição',
  'estudante.validation.contact.length': 'O contacto deve ter exactamente 9 dígitos',
  'estudante.create.print': 'Imprimir Comprovativo',
  'estudante.error.duplicate.mobile': 'Já existe um estudante com este número de telefone',
  'estudante.error.print': 'Erro ao gerar o documento',
  'estudante.field.turma.curso': 'Curso',
  'estudante.field.turma.classe': 'Classe',
  'estudante.field.turma.nivel': 'Nível',
  'estudante.field.classroom': 'Turma',
  'estudante.list.stat.active': 'estudantes activos',
  'estudante.list.action.print.comprovativo': 'Comprovativo de Cadastro',
  'estudante.list.action.print.ficha': 'Ficha de Estudante',
  'estudante.extras.add.title': 'Adicionar Extra',
  'estudante.extras.add.empty': 'Não existem extras disponíveis para adicionar a este estudante.',
  'estudante.extras.add.success': 'Extra adicionado com sucesso',
  'estudante.extras.remove.title': 'Remover Extra',
  'estudante.extras.remove.empty': 'Este estudante não tem extras associados.',
  'estudante.extras.remove.confirm': 'Tem a certeza que deseja remover este extra do estudante?',
  'estudante.extras.remove.success': 'Extra removido com sucesso',
  'estudante.extras.select': 'Seleccione um extra',
  'estudante.extras.error': 'Erro ao processar o extra',
  'estudante.list.confirm.inactivate':
    'Tem a certeza que deseja inactivar este estudante? Ele permanecerá no sistema como inactivo.',
  'estudante.list.inactivate.default.reason': 'Inactivado a partir da lista de estudantes',
  'estudante.list.confirm.remove':
    'Esta acção é irreversível. Tem a certeza que deseja remover este estudante?',
  'estudante.notify.title.count': 'Notificar ({count}) Contactos',
  'estudante.notify.type': 'Tipo de Notificação',
  'estudante.notify.type.convocatoria': 'Convocatória',
  'estudante.notify.type.comunicado': 'Comunicado',
  'estudante.notify.meetingDate': 'Data da Reunião',
  'estudante.notify.meetingTime': 'Hora da Reunião',
  'estudante.notify.agenda1': 'Ponto 1 da Agenda',
  'estudante.notify.agenda1.placeholder': 'ex. Abertura',
  'estudante.notify.agenda2': 'Ponto 2 da Agenda (opcional)',
  'estudante.notify.agenda2.placeholder': 'ex. Resultados académicos',
  'estudante.notify.agenda3': 'Ponto 3 da Agenda (opcional)',
  'estudante.notify.agenda3.placeholder': 'ex. Actividades escolares',
  'estudante.notify.agenda4': 'Ponto 4 da Agenda (opcional)',
  'estudante.notify.agenda4.placeholder': 'ex. Outros assuntos',
  'estudante.notify.notes': 'Notas adicionais (opcional)',
  'estudante.notify.message': 'Mensagem do Comunicado',
  'estudante.notify.message.placeholder': 'ex. as aulas retomam no dia 5 de Junho.',
  'estudante.notify.preview': 'Pré-visualização da Mensagem',
  'estudante.notify.preview.convocatoria':
    'Caro encarregado de educação, {sucursal} convida-o para uma reunião a realizar-se no dia {date} às {time}, com a seguinte agenda:\n\n{agenda}\n\nNotas importantes: {notes}\nEm caso de dúvidas, contacte a secretaria.',
  'estudante.notify.preview.comunicado':
    'Caro encarregado de educação, {sucursal} informa que {message}.\n\nCom os melhores cumprimentos.',
  'estudante.notify.success': 'Notificação enviada com sucesso',
  'estudante.notify.error': 'Erro ao enviar a notificação',

  'notificacoes.breadcrumb': 'Notificações',
  'notificacoes.send.title': 'Enviar Comunicado',
  'notificacoes.send.subtitle':
    'Envie uma mensagem para os encarregados de todos os estudantes activos do ano lectivo seleccionado.',
  'notificacoes.send.action': 'Enviar a Todos os Estudantes Activos',
  'notificacoes.send.error': 'Erro ao enviar o comunicado',
  'notificacoes.error.noRecipients': 'Não existem contactos válidos para notificar',
  'notificacoes.history.title': 'Histórico de Notificações',
  'notificacoes.history.subtitle': 'Notificações enviadas anteriormente para esta sucursal.',
  'notificacoes.history.message': 'Mensagem',
  'notificacoes.history.status': 'Estado',
  'notificacoes.history.sentAt': 'Data de Envio',
  'notificacoes.history.empty': 'Ainda não foram enviadas notificações.',
  'notificacoes.filter.today': 'Hoje',
  'notificacoes.filter.week': 'Esta Semana',
  'notificacoes.filter.month': 'Este Mês',
  'notificacoes.filter.from': 'De',
  'notificacoes.filter.to': 'Até',
  'notificacoes.status.sent': 'Enviado',
  'notificacoes.status.delivered': 'Entregue',
  'notificacoes.status.read': 'Lido',
  'notificacoes.status.failed': 'Falhou',
  'notificacoes.details.message': 'Mensagem Enviada',
  'notificacoes.details.attachment': 'Anexo',
  'notificacoes.details.viewAttachment': 'Ver anexo',
  'notificacoes.details.noAttachment': 'Sem anexo',
  'notificacoes.details.sentAt': 'Hora de Envio',
  'notificacoes.details.deliveredAt': 'Hora de Entrega',
  'notificacoes.details.readAt': 'Hora de Leitura',
  'estudante.edit.recalculate': 'Recalcular Valores',

  // Utilizadores — esta tela não recolhe dados pessoais livres: converte um
  // Professor ou Funcionário já cadastrado numa conta de acesso ao sistema,
  // escolhendo primeiro o Perfil e depois o registo a associar.
  'utilizador.breadcrumb.create': 'Cadastrar Utilizador',
  'utilizador.breadcrumb.list': 'Lista de Utilizadores',
  'utilizador.breadcrumb.edit': 'Editar Utilizador',
  'utilizador.wizard.title': 'Cadastrar Novo Utilizador',
  'utilizador.wizard.subtitle':
    'Seleccione o perfil e o registo a associar; os dados de contacto são preenchidos automaticamente.',
  'utilizador.wizard.step.profile': 'Perfil e Associação',
  'utilizador.wizard.step.sucursais': 'Sucursais',
  'utilizador.wizard.step.confirm': 'Confirmação',
  'utilizador.field.profile': 'Perfil',
  'utilizador.field.teacher': 'Seleccionar Professor',
  'utilizador.field.worker': 'Funcionário',
  'utilizador.field.name': 'Nome',
  'utilizador.field.email': 'Email',
  'utilizador.field.contact': 'Contacto',
  'utilizador.field.username': 'Nome de Utilizador',
  'utilizador.field.sucursais': 'SUCURSAIS',
  'utilizador.field.sucursais.hint': 'Clique para seleccionar uma ou mais sucursais.',
  'utilizador.select.placeholder': 'Seleccione...',
  'utilizador.personal.info': 'Informações do Utilizador',
  'utilizador.confirm.description': 'Confirme os dados abaixo antes de submeter.',
  'utilizador.create.success.title': 'Utilizador cadastrado com sucesso',
  'utilizador.create.success.subtitle': 'Nome de utilizador gerado',
  'utilizador.create.new': 'Cadastrar Outro Utilizador',
  'utilizador.validation.profile.required': 'Por favor informe o Perfil',
  'utilizador.validation.teacher.required': 'Por favor seleccione o Professor',
  'utilizador.validation.worker.required': 'Por favor seleccione o Funcionário',
  'utilizador.validation.sucursal.required': 'Por favor informe a SUCURSAL',
  'utilizador.validation.contact.length': 'O contacto deve ter exactamente 9 dígitos',
  'utilizador.list.title': 'Utilizadores',
  'utilizador.list.subtitle': 'Consulte, edite e active/desactive os utilizadores do sistema.',
  'utilizador.list.search.placeholder': 'Pesquisar por nome, email, contacto ou perfil',
  'utilizador.list.add': 'Adicionar Novo Utilizador',
  'utilizador.list.empty': 'Nenhum utilizador encontrado',
  'utilizador.list.loading': 'A carregar...',
  'utilizador.list.total': 'utilizador(es)',
  'utilizador.list.activate': 'Activar',
  'utilizador.list.inactivate': 'Desactivar',
  'utilizador.list.activate.success': 'Utilizador activado com sucesso',
  'utilizador.list.inactivate.success': 'Utilizador desactivado com sucesso',
  'utilizador.list.toggle.error': 'Erro ao alterar o estado do utilizador',
  'utilizador.list.action.resetPassword': 'Redefinir Senha',
  'utilizador.list.resetPassword.confirm':
    'Tem a certeza que deseja redefinir a senha deste utilizador?',
  'utilizador.list.resetPassword.success': 'Senha redefinida com sucesso',
  'utilizador.list.resetPassword.error': 'Erro ao redefinir a senha do utilizador',
  'utilizador.expand.username': 'Nome de Utilizador',
  'utilizador.expand.registerDate': 'Data de Cadastro',
  'utilizador.edit.title': 'Editar Utilizador',
  'utilizador.edit.subtitle': 'Actualize os dados do utilizador e guarde as alterações.',
  'utilizador.edit.success': 'Utilizador actualizado com sucesso',
  'utilizador.edit.not.found': 'Utilizador não encontrado. Volte à lista e tente novamente.',
  'utilizador.edit.back.to.list': 'Voltar à Lista',

  'propina.breadcrumb.list': 'Propinas',
  'propina.breadcrumb.confirm': 'Confirmar Pagamento',
  'propina.breadcrumb.amortize': 'Amortizar Dívida',

  'propina.stat.total': 'estudante(s)',
  'propina.stat.overdue': 'em atraso',
  'propina.list.title': 'Propinas',
  'propina.list.subtitle': 'Consulte e registe os pagamentos das mensalidades dos estudantes.',
  'propina.filter.name': 'Nome do Estudante',
  'propina.filter.name.placeholder': 'Digite o nome do aluno...',
  'propina.col.enrolledAt': 'Data de Inscrição',
  'propina.col.debt': 'Valor em Dívida',
  'propina.col.level.curso': 'Curso',
  'propina.col.level.classe': 'Classe',
  'propina.col.level.nivel': 'Nível',
  'propina.col.year': 'Ano',
  'propina.field.scheduleType': 'Horário',
  'propina.field.monthlyPaymentBasis': 'Mensalidade Horário',
  'propina.col.month': 'Mês',
  'propina.col.propina': 'Propina',
  'propina.col.extras': 'Extras',
  'propina.col.total': 'Total',
  'propina.col.limitDate': 'Data Limite',
  'propina.debt.tooltip': 'Clique para amortizar esta dívida',

  // Secções dentro do expandir de um estudante na lista de Propinas:
  // Propinas e Extras (mensalidades) → Taxas → Pagamentos Agregados.
  'propina.section.propinasExtras': 'Propinas e Extras',
  'propina.section.taxes': 'Taxas',
  'propina.confirm.payTaxRemainderTitle': 'Pagamento do Remanescente da Taxa',

  // "Pagamentos Agregados" — transacções que cobrem várias mensalidades e/ou
  // taxas de uma só vez (Facturação Agregada), listadas dentro do expandir
  // de cada estudante na lista de Propinas.
  'propina.aggregated.title': 'Pagamentos Agregados',
  'propina.aggregated.col.date': 'Data',
  'propina.aggregated.col.discount': 'Desconto',
  'propina.aggregated.col.paid': 'Valor Pago',
  'propina.aggregated.col.method': 'Método',
  'propina.aggregated.col.description': 'Descrição',
  'propina.aggregated.col.qty': 'Qtd',
  'propina.aggregated.action.print': 'Imprimir',
  'propina.action.printExtracto': 'Imprimir Extracto',
  'propina.action.anular': 'Anular',
  'propina.action.removeFine': 'Remover Multa',
  'propina.action.receipt': 'Comprovativo',
  'propina.action.payExtras': 'Pagr. Extras',
  'propina.action.payRemainder': 'Pagar Remanescente',
  'propina.action.pay': 'Pagar',
  'propina.action.pay.locked': 'Pague primeiro a taxa de Inscrição/Renovação em dívida',
  'propina.action.remove': 'Remover',
  'propina.action.invoice': 'Factura',
  'propina.action.backToPayments': 'Voltar aos Pagamentos',
  'propina.status.paid': 'Pago',
  'propina.status.partial': 'Pagto Parcial',
  'propina.status.unpaid': 'Não Pago',
  'propina.detail.monthlyValue': 'Valor Mensal (Propina)',
  'propina.detail.discount': 'Desconto',
  'propina.detail.iva': 'IVA',
  'propina.detail.fine': 'Multa',
  'propina.detail.propinaStatus': 'Estado da Propina',
  'propina.detail.paymentDate': 'Data de Pagamento',
  'propina.detail.paymentMethod': 'Método de Pagamento',
  'propina.detail.paidAmount': 'Valor Pago',
  'propina.detail.remainingAmount': 'Valor Remanescente',
  'propina.detail.extrasTotal': 'Total Extras',
  'propina.detail.combinedTotal': 'Total Geral (Propina + Extras)',
  'propina.detail.reference': 'Referência',
  'propina.documento.extracto': 'Extracto de Pagamentos — {name}',
  'propina.documento.receipt': 'Comprovativo de Pagamento — {month}/{year}',
  'propina.documento.receiptRemainder': 'Remanescente de {month}',
  'propina.documento.amortization': 'Factura de Amortização — {name}',
  'propina.extras.default': 'Actividade',
  'propina.extras.noneUnpaid': 'Não há extras por pagar',
  'propina.extras.revert': 'Anular',
  'propina.extras.confirmRemove': 'Tem a certeza que deseja remover o extra "{name}"?',
  'propina.extras.confirmRevert': 'Tem a certeza que deseja anular o pagamento do extra "{name}"?',
  'propina.extras.removeSuccess': 'Extra removido com sucesso',
  'propina.extras.revertSuccess': 'Pagamento do extra anulado com sucesso',
  'propina.extras.editTitle': 'Editar Valor do Extra',
  'propina.extras.editSubtitle': 'A editar o valor de "{name}".',
  'propina.extras.amount': 'Valor',
  'propina.extras.invalidAmount': 'Informe um valor válido',
  'propina.extras.editSuccess': 'Valor do extra actualizado com sucesso',
  'propina.error.print': 'Erro ao gerar o documento',
  'propina.error.generic': 'Erro ao processar o pedido',
  'propina.error.previousUnpaid': 'Não pode pagar {month} antes de pagar {previousMonth}',
  'propina.error.registrationTaxPending':
    'A taxa de Inscrição/Renovação ainda não foi totalmente paga. Liquide-a primeiro para poder pagar mensalidades.',
  'propina.confirm.anular': 'Tem a certeza que deseja anular este pagamento?',
  'propina.anular.success': 'Pagamento anulado com sucesso',
  'propina.removeFine.title': 'Remover Multa',
  'propina.removeFine.confirmText': 'Tem a certeza que deseja remover a multa deste pagamento?',
  'propina.removeFine.reason': 'Motivo da remoção',
  'propina.removeFine.reason.placeholder': 'Informe o motivo da remoção da multa...',
  'propina.removeFine.reasonRequired': 'Por favor, informe o motivo da remoção da multa.',
  'propina.removeFine.success': 'Multa removida com sucesso',
  'propina.removeFine.confirm': 'Confirmar Remoção',

  'propina.confirm.removePropina': 'Tem a certeza que deseja remover esta mensalidade? Esta acção é irreversível — o registo será apagado definitivamente e não poderá ser recuperado.',
  'propina.remove.success': 'Mensalidade removida com sucesso',

  'propina.tax.action.remove': 'Remover',
  'propina.tax.confirm.remove': 'Tem a certeza que deseja remover esta taxa do aluno? Esta acção é irreversível — o registo será apagado definitivamente e não poderá ser recuperado.',
  'propina.tax.remove.success': 'Taxa removida com sucesso',
  'propina.tax.error.remove': 'Erro ao remover a taxa. Verifique se já não foi paga.',

  'propina.tax.action.anular': 'Anular',
  'propina.tax.confirm.anular': 'Tem a certeza que deseja anular esta taxa? O pagamento voltará ao estado de Não Pago.',
  'propina.tax.anular.success': 'Taxa anulada com sucesso',

  'propina.confirm.notFound': 'Pagamento não encontrado. Volte à lista de Propinas e tente novamente.',
  'propina.confirm.title': 'Confirmação do Pagamento',
  'propina.confirm.subtitle': 'Informe os campos abaixo e clique em confirmar.',
  'propina.confirm.remainderTitle': 'Pagamento do Valor Remanescente',
  'propina.confirm.remainderSubtitle': 'Este pagamento é referente ao saldo em dívida de um pagamento parcial. Informe os campos abaixo e clique em confirmar.',
  'propina.summary.alreadyPaid': 'Já Pago',
  'propina.summary.propinaTotal': 'Total da Propina',
  'propina.summary.extrasTotal': 'Total Extras',
  'propina.summary.totalToPay': 'Total a Pagar',
  'propina.field.paymentMethod': 'Forma de Pagamento',
  'propina.field.paymentDate': 'Data de Pagamento',
  'propina.field.amountToPay': 'Valor a Pagar',
  'propina.field.paymentOption': 'Opção de Pagamento',
  'propina.field.paymentOption.all': 'Propina + Extras ({value})',
  'propina.field.paymentOption.propina': 'Apenas Propina ({value})',
  'propina.field.paymentOption.extras': 'Apenas Extras ({value})',
  'propina.field.forgiveFine': 'Pagar Sem Multa?',
  'propina.field.amountPaid': 'Valor a Pagar',
  'propina.field.amountPaid.remaining': 'Fica em dívida: {value}',
  'propina.field.amountPaid.overMax': 'O valor não pode ser maior que {value}',
  'propina.confirm.success.title': 'Pagamento realizado com sucesso',
  'propina.confirm.success.subtitle': 'O pagamento foi processado com sucesso.',

  'propina.amortize.totalDebt': 'Total em Dívida',
  'propina.amortize.overdueTitle': 'Pagamentos em Atraso',
  'propina.amortize.overdueEmpty': 'Nenhum pagamento em atraso encontrado.',
  'propina.amortize.amountToPay': 'Valor a Pagar',
  'propina.amortize.paymentMethod.entidade': 'Entidade e Referência',
  'propina.amortize.confirm': 'Confirmar Pagamento',
  'propina.amortize.success.title': 'Pagamento Realizado com Sucesso',
  'propina.amortize.success.subtitle': 'O pagamento de {value} foi processado.',
  'propina.amortize.error.negative': 'O valor não pode ser negativo',
  'propina.amortize.error.exceeds': 'O valor não pode ser maior que {amount}',
  'propina.amortize.error.method': 'Seleccione um método de pagamento',
  'propina.amortize.error.value': 'Insira um valor válido para pagar',

  'documento.title': 'Pré-visualização do Documento',
  'documento.download': 'Download',
  'documento.print': 'Imprimir',
  'documento.notFound': 'Nenhum documento para pré-visualizar. Volte atrás e tente novamente.',
  'documento.error': 'Não foi possível carregar a pré-visualização do documento.',
  'documento.openExternal': 'Abrir num novo separador',
  'documento.corsDownloadHint':
    'O documento abriu num novo separador — use o ícone de download do próprio visualizador de PDF para o guardar.',
  'documento.corsPrintHint':
    'O documento abriu num novo separador — use o ícone de impressão do próprio visualizador de PDF, ou Ctrl+P (Cmd+P).',

  'bulk.breadcrumb': 'Facturação Agregada',
  'bulk.title': 'Facturação Agregada',
  'bulk.subtitle':
    'Pague várias propinas de uma vez — de um único estudante (com desconto, taxas e extras) ou de vários estudantes que partilhem o mesmo encarregado.',
  'bulk.error.carierMismatch':
    'Todos os estudantes seleccionados devem partilhar o mesmo contacto do encarregado para poderem ser pagos em grupo.',
  'bulk.field.searchStudent': 'Pesquisar Estudante',
  'bulk.field.searchStudent.placeholder': 'Digite o nome ou código...',
  'bulk.field.selectStudents': 'Seleccionar Estudantes',
  'bulk.field.selectStudents.hint':
    'Seleccione 1 estudante para facturar propinas + taxas + extras com desconto, ou 2+ estudantes com o mesmo encarregado para um pagamento em grupo.',
  'bulk.hint.selectAtLeastOne': 'Seleccione pelo menos um estudante para continuar.',
  'bulk.section.payments': 'Propinas por Pagar',
  'bulk.action.selectAll': 'Seleccionar Todos',
  'bulk.col.amountToPay': 'Valor a Pagar',
  'bulk.hint.noPendingPayments': 'Não há propinas por pagar para a selecção actual.',
  'bulk.section.taxes': 'Taxas e Emolumentos',
  'bulk.col.taxName': 'Nome da Taxa',
  'bulk.col.taxType': 'Tipo',
  'bulk.section.config': 'Configuração do Pagamento',
  'bulk.field.payOnlyPropina': 'Incluir Extras?',
  'bulk.field.payOnlyPropina.with': 'Propina + Extras',
  'bulk.field.payOnlyPropina.only': 'Apenas Propina',
  'bulk.field.discountType': 'Tipo de Desconto',
  'bulk.field.discountValue': 'Valor do Desconto',
  'bulk.field.discountScope': 'Aplicar Desconto a',
  'bulk.discount.scope.propinas': 'Propinas',
  'bulk.discount.scope.taxes': 'Taxas',
  'bulk.discount.scope.propinasExtras': 'Propinas + Extras',
  'bulk.discount.scope.propinasTaxes': 'Propinas + Taxas',
  'bulk.discount.scope.all': 'Propinas + Extras + Taxas',
  'bulk.section.summary': 'Resumo',
  'bulk.summary.original': 'Total Original',
  'bulk.summary.discount': 'Desconto',
  'bulk.summary.final': 'Total a Pagar',
  'bulk.summary.info': '{payments} propina(s) e {taxes} taxa(s) seleccionadas — forma de pagamento: {method}.',
  'bulk.action.confirmPayment': 'Confirmar Pagamento — {value}',
  'bulk.section.groupedPayments': 'Propinas Agrupadas por Mês',
  'bulk.col.students': 'Estudantes',
  'bulk.section.groupConfig': 'Config. Pagamento em Grupo',
  'bulk.field.amountPaid': 'Valor Pago',
  'bulk.field.amountPaid.remaining': 'Ficará uma dívida remanescente de {value}',
  'bulk.error.groupMinItems': 'É necessário seleccionar pelo menos 2 propinas para um pagamento em grupo.',
  'bulk.error.groupAmountRequired': 'Informe um valor pago válido.',
  'bulk.error.noItems': 'Seleccione pelo menos uma propina ou taxa.',
  'bulk.confirm.title': 'Confirmar Facturação',
  'bulk.success.title': 'Pagamento processado com sucesso',
  'bulk.success.subtitle': 'A facturação agregada foi processada com sucesso.',
  'bulk.success.subtitleGroup': 'O pagamento em grupo foi processado com sucesso.',
  'bulk.summary.totalProcessed': 'Total Processado',
  'bulk.summary.successful': 'Sucesso',
  'bulk.summary.failed': 'Falhas',
  'bulk.summary.taxesCreated': 'Taxas Criadas',
  'bulk.col.paidAmount': 'Valor Pago',
  'bulk.col.remaining': 'Dívida Restante',
  'bulk.action.newPayment': 'Novo Pagamento',
  'bulk.receiptTitle': 'Comprovativo — Facturação Agregada',

  'global.loading': 'A processar...',

  'presenca.breadcrumb': 'Lista de Presenças de Estudantes',
  'presenca.field.year': 'Ano Lectivo',
  'presenca.field.turma': 'Turma',
  'presenca.field.turma.placeholder': 'Seleccione uma turma',
  'presenca.field.date': 'Data',
  'presenca.field.justification.placeholder': 'Motivo da justificação',
  'presenca.hint.selectTurma': 'Seleccione uma turma para marcar as presenças.',
  'presenca.hint.noStudents': 'Esta turma não tem estudantes alocados.',
  'presenca.stat.present': 'Presentes',
  'presenca.stat.absent': 'Ausentes',
  'presenca.stat.justified': 'Com Justificação',
  'presenca.stat.total': 'Total',
  'presenca.col.name': 'Nome do Estudante',
  'presenca.col.status': 'Estado',
  'presenca.col.justification': 'Justificação',
  'presenca.status.present': 'Presente',
  'presenca.status.absent': 'Ausente',
  'presenca.status.justified': 'Justificado',
  'presenca.action.save': 'Guardar Presenças',
  'presenca.action.print': 'Imprimir',
  'presenca.success.saved': 'Presenças guardadas com sucesso.',
  'presenca.error.loadClassrooms': 'Erro ao carregar as turmas.',
  'presenca.error.loadRoster': 'Erro ao carregar a lista de estudantes.',
  'presenca.error.save': 'Erro ao guardar as presenças.',
  'presenca.error.print': 'Erro ao gerar o documento.',
  'presenca.documento.title': 'Lista de Presenças — {className} — {date}',

  'turma.breadcrumb.create': 'Criar Turmas',
  'turma.breadcrumb.list': 'Lista de Turmas',
  'turma.wizard.title': 'Criar Nova Turma',
  'turma.wizard.subtitle': 'Preencha os dados abaixo e avance pelos passos seguintes.',
  'turma.wizard.step.data': 'Dados da Turma',
  'turma.wizard.step.teachers': 'Professores',
  'turma.wizard.step.confirm': 'Confirmação',
  'turma.confirm.description': 'Confirme os dados abaixo antes de submeter.',
  'turma.action.createAnother': 'Criar Outra Turma',
  'turma.field.className': 'Nome da Turma',
  'turma.field.code': 'Código',
  'turma.field.academicYear': 'Ano Lectivo',
  'turma.field.educationLevel.curso': 'Curso',
  'turma.field.educationLevel.classe': 'Classe',
  'turma.field.educationLevel.nivel': 'Nível',
  'turma.field.educationLevel.placeholder.curso': 'Seleccione um curso',
  'turma.field.educationLevel.placeholder.classe': 'Seleccione uma classe',
  'turma.field.educationLevel.placeholder.nivel': 'Seleccione um nível',
  'turma.field.shift': 'Turno',
  'turma.field.maxStudents': 'Nº Máximo de Estudantes',
  'turma.field.teachers': 'Professores',
  'turma.field.teachers.placeholder': 'Seleccione os professores...',
  'turma.field.students': 'Estudantes',
  'turma.field.searchStudent.placeholder': 'Pesquisar e seleccionar estudantes...',
  'turma.hint.noTeachers': 'Nenhum professor cadastrado.',
  'turma.hint.noStudentsPool': 'Nenhum estudante activo encontrado.',
  'turma.hint.noClassrooms': 'Nenhuma turma encontrada para este ano lectivo.',
  'turma.hint.selectedCount': '{count} estudante(s) seleccionado(s)',
  'turma.action.create': 'Criar Turma',
  'turma.action.edit': 'Editar Turma',
  'turma.action.allocateStudents': 'Alocar Alunos',
  'turma.action.nominalList': 'Lista Nominal',
  'turma.col.className': 'Turma',
  'turma.col.educationLevel.curso': 'Curso',
  'turma.col.educationLevel.classe': 'Classe',
  'turma.col.educationLevel.nivel': 'Nível',
  'turma.col.shift': 'Turno',
  'turma.col.teachers': 'Professores',
  'turma.col.students': 'Alunos',
  'turma.col.actions': 'Acções',
  'turma.confirm.delete': 'Tem a certeza que deseja eliminar a turma "{name}"?',
  'turma.success.created': 'Turma criada com sucesso.',
  'turma.success.updated': 'Turma actualizada com sucesso.',
  'turma.success.deleted': 'Turma eliminada com sucesso.',
  'turma.success.allocated': 'Alunos alocados com sucesso.',
  'turma.error.requiredFields': 'Preencha todos os campos obrigatórios.',
  'turma.error.create': 'Erro ao criar a turma.',
  'turma.error.update': 'Erro ao actualizar a turma.',
  'turma.error.delete': 'Erro ao eliminar a turma.',
  'turma.error.allocate': 'Erro ao alocar os alunos.',
  'turma.error.load': 'Erro ao carregar as turmas.',
  'turma.error.print': 'Erro ao gerar o documento.',
  'turma.documento.nominalList': 'Lista Nominal — {className}',
  'turma.list.subtitle': 'Consulte, edite e faça a gestão das turmas, professores e alunos alocados.',
  'turma.list.search.placeholder': 'Pesquisar por nome da turma...',
  'turma.list.total': 'turma(s)',
  'turma.list.stat.total': 'turmas',
  'turma.list.stat.students': 'estudantes alocados',
  'turma.list.stat.available': 'vagas disponíveis',
  'turma.expand.tab.details': 'Detalhes',
  'turma.expand.tab.students': 'Estudantes',
  'turma.expand.empty.students': 'Nenhum estudante alocado nesta turma.',
  'turma.allocate.unallocated': 'Não Alocados',
  'turma.allocate.allocated': 'Alocados',
  'turma.allocate.search.placeholder': 'Pesquisar estudante...',
  'turma.allocate.selectAll': 'Seleccionar Todos',
  'turma.allocate.empty.unallocated': 'Nenhum estudante disponível para alocar.',
  'turma.allocate.empty.allocated': 'Nenhum estudante alocado.',
  'turma.allocate.error.notFound': 'Turma não encontrada. Abra a partir da lista de turmas.',
  'turma.allocate.error.capacity': 'O número de estudantes seleccionados excede a capacidade máxima desta turma.',
  'turma.allocate.error.empty': 'Seleccione pelo menos um estudante para alocar.',
  'turma.wizard.step.students': 'Estudantes',

  'disciplina.breadcrumb': 'Disciplinas',
  'disciplina.breadcrumb.list': 'Lista de Disciplinas',
  'disciplina.breadcrumb.create': 'Cadastrar Disciplina',
  'disciplina.list.subtitle': 'Consulte as disciplinas cadastradas e adicione novas.',
  'disciplina.list.add': 'Adicionar Disciplina',
  'disciplina.list.search.placeholder': 'Pesquisar por nome, código ou abreviatura',
  'disciplina.list.total': 'disciplina(s)',
  'disciplina.list.stat.total': 'Total de Disciplinas',
  'disciplina.list.stat.curricular': 'Curriculares',
  'disciplina.list.stat.dispensa': 'Permitem Dispensa',
  'disciplina.wizard.title': 'Cadastrar Disciplina',
  'disciplina.wizard.subtitle': 'Preencha os dados abaixo e avance pelos passos seguintes.',
  'disciplina.wizard.step.data': 'Dados da Disciplina',
  'disciplina.wizard.step.settings': 'Configurações',
  'disciplina.wizard.step.confirm': 'Confirmação',
  'disciplina.confirm.description': 'Confirme os dados abaixo antes de submeter.',
  'disciplina.action.createAnother': 'Cadastrar Outra Disciplina',
  'disciplina.section.list': 'Lista de Disciplinas',
  'disciplina.field.subjectName': 'Nome da Disciplina',
  'disciplina.field.level.curso': 'Curso',
  'disciplina.field.level.classe': 'Classe',
  'disciplina.field.level.nivel': 'Nível',
  'disciplina.field.code': 'Código',
  'disciplina.field.abbreviation': 'Abreviatura',
  'disciplina.field.totalCredits': 'Créditos',
  'disciplina.field.isCurricular': 'Curricular',
  'disciplina.field.hasDispensa': 'Permite Dispensa',
  'disciplina.filter.allLevels.curso': 'Todos os cursos',
  'disciplina.filter.allLevels.classe': 'Todas as classes',
  'disciplina.filter.allLevels.nivel': 'Todos os níveis',
  'disciplina.action.create': 'Cadastrar Disciplina',
  'disciplina.hint.noSubjects': 'Nenhuma disciplina encontrada.',
  'disciplina.success.created': 'Disciplina criada com sucesso.',
  'disciplina.error.requiredFields.curso': 'Preencha o nome da disciplina e o curso.',
  'disciplina.error.requiredFields.classe': 'Preencha o nome da disciplina e a classe.',
  'disciplina.error.requiredFields.nivel': 'Preencha o nome da disciplina e o nível.',
  'disciplina.error.create': 'Erro ao criar a disciplina.',
  'disciplina.error.load': 'Erro ao carregar as disciplinas.',

  'avaliacao.breadcrumb': 'Avaliações',
  'avaliacao.breadcrumb.list': 'Lista de Avaliações',
  'avaliacao.breadcrumb.create': 'Criar Avaliação',
  'avaliacao.wizard.title': 'Criar Avaliação',
  'avaliacao.wizard.subtitle': 'Preencha os dados abaixo e avance pelos passos seguintes.',
  'avaliacao.wizard.step.context.curso': 'Curso e Disciplina',
  'avaliacao.wizard.step.context.classe': 'Classe e Disciplina',
  'avaliacao.wizard.step.context.nivel': 'Nível e Disciplina',
  'avaliacao.wizard.step.data': 'Dados da Avaliação',
  'avaliacao.wizard.step.confirm': 'Confirmação',
  'avaliacao.confirm.description': 'Confirme os dados abaixo antes de submeter.',
  'avaliacao.action.createAnother': 'Criar Outra Avaliação',
  'avaliacao.section.list': 'Avaliações do Período',
  'avaliacao.list.subtitle': 'Consulte as avaliações do período seleccionado e adicione novas.',
  'avaliacao.list.add': 'Adicionar Avaliação',
  'avaliacao.list.stat.total': 'Total de Avaliações',
  'avaliacao.list.stat.totalWeight': 'Peso Total',
  'avaliacao.field.subject.placeholder': 'Seleccione uma disciplina',
  'avaliacao.field.period': 'Período',
  'avaliacao.field.name': 'Nome da Avaliação',
  'avaliacao.field.weight': 'Peso (%)',
  'avaliacao.field.type': 'Tipo',
  'avaliacao.field.category': 'Categoria',
  'avaliacao.field.category.placeholder': 'Seleccione uma categoria',
  'avaliacao.action.create': 'Criar Avaliação',
  'avaliacao.action.createComportamento': 'Criar disciplina "Comportamento"',
  'avaliacao.hint.selectSubject.curso': 'Seleccione o curso e a disciplina para ver/criar avaliações.',
  'avaliacao.hint.selectSubject.classe': 'Seleccione a classe e a disciplina para ver/criar avaliações.',
  'avaliacao.hint.selectSubject.nivel': 'Seleccione o nível e a disciplina para ver/criar avaliações.',
  'avaliacao.hint.noEvaluations': 'Nenhuma avaliação encontrada para este período.',
  'avaliacao.hint.totalWeight': 'Peso total: {total}%/100%',
  'avaliacao.confirm.delete': 'Tem a certeza que deseja eliminar a avaliação "{name}"?',
  'avaliacao.success.created': 'Avaliação criada com sucesso.',
  'avaliacao.success.deleted': 'Avaliação eliminada com sucesso.',
  'avaliacao.error.requiredFields.curso': 'Preencha o curso, a disciplina e o nome da avaliação.',
  'avaliacao.error.requiredFields.classe': 'Preencha a classe, a disciplina e o nome da avaliação.',
  'avaliacao.error.requiredFields.nivel': 'Preencha o nível, a disciplina e o nome da avaliação.',
  'avaliacao.error.requiredContext.curso': 'Seleccione o curso e a disciplina.',
  'avaliacao.error.requiredContext.classe': 'Seleccione a classe e a disciplina.',
  'avaliacao.error.requiredContext.nivel': 'Seleccione o nível e a disciplina.',
  'avaliacao.error.requiredName': 'Preencha o nome da avaliação.',
  'avaliacao.error.requiredCategory': 'Seleccione a categoria da avaliação.',
  'avaliacao.error.createComportamento': 'Erro ao criar a disciplina "Comportamento".',
  'avaliacao.error.create': 'Erro ao criar a avaliação.',
  'avaliacao.error.delete': 'Erro ao eliminar a avaliação.',
  'avaliacao.error.load': 'Erro ao carregar as avaliações.',

  'inactivos.breadcrumb': 'Estudantes Inactivos',
  'inactivos.col.reason': 'Motivo',
  'inactivos.col.inactivatedAt': 'Data de Inactivação',
  'inactivos.action.reactivate': 'Reactivar',
  'inactivos.hint.noStudents': 'Nenhum estudante inactivo encontrado.',
  'inactivos.confirm.reactivate': 'Tem a certeza que deseja reactivar "{name}"?',
  'inactivos.success.reactivated': 'Estudante reactivado com sucesso.',
  'inactivos.error.reactivate': 'Erro ao reactivar o estudante.',
  'inactivos.error.load': 'Erro ao carregar os estudantes inactivos.',

  'presencaColab.breadcrumb': 'Lista de Presenças de Colaboradores',
  'presencaColab.field.year': 'Ano',
  'presencaColab.field.month': 'Mês',
  'presencaColab.field.month.all': 'Todos os meses',
  'presencaColab.field.search': 'Pesquisar',
  'presencaColab.field.search.placeholder': 'Pesquisar por nome',
  'presencaColab.field.startDate': 'Data Início',
  'presencaColab.field.endDate': 'Data Fim',
  'presencaColab.field.justification': 'Justificação',
  'presencaColab.field.justificationType': 'Tipo de Justificação',
  'presencaColab.col.employee': 'Colaborador',
  'presencaColab.col.complete': 'Presenças Completas',
  'presencaColab.col.incomplete': 'Presenças Incompletas',
  'presencaColab.col.justified': 'Faltas Justificadas',
  'presencaColab.col.unjustified': 'Faltas não Justificadas',
  'presencaColab.col.entry': 'Entrada',
  'presencaColab.col.exit': 'Saída',
  'presencaColab.col.actions': 'Ações',
  'presencaColab.status.COMPLETE': 'Completo',
  'presencaColab.status.INCOMPLETE': 'Incompleto',
  'presencaColab.status.ABSENT': 'Ausente',
  'presencaColab.action.entrance': 'Registar Entrada',
  'presencaColab.action.exit': 'Registar Saída',
  'presencaColab.action.justify': 'Justificar',
  'presencaColab.action.print': 'Imprimir Relatório',
  'presencaColab.action.printIndividual': 'Imprimir',
  'presencaColab.action.printIndividual.title': 'Imprimir presenças de {name}',
  'presencaColab.hint.noEmployees': 'Nenhum colaborador encontrado.',
  'presencaColab.hint.noRecords': 'Nenhum registo encontrado para o período seleccionado.',
  'presencaColab.justifyModal.title': 'Justificar Ausência — {date}',
  'presencaColab.documento.title': 'Lista de Presenças de Colaboradores — {startDate} a {endDate}',
  'presencaColab.documento.individualTitle': 'Presenças de {name} — {startDate} a {endDate}',
  'presencaColab.success.entrance': 'Entrada registada com sucesso.',
  'presencaColab.success.exit': 'Saída registada com sucesso.',
  'presencaColab.success.justified': 'Justificação registada com sucesso.',
  'presencaColab.error.entrance': 'Erro ao registar entrada.',
  'presencaColab.error.exit': 'Erro ao registar saída.',
  'presencaColab.error.justify': 'Erro ao registar a justificação.',
  'presencaColab.error.justificationRequired': 'Escreva a justificação.',
  'presencaColab.error.load': 'Erro ao carregar as presenças.',
  'presencaColab.error.print': 'Erro ao gerar o relatório.',
  'presencaColab.error.printIndividual': 'Erro ao gerar o relatório individual.',

  'nota.breadcrumb.lancamento': 'Lançamento de Notas',
  'nota.breadcrumb.lista': 'Lista de Notas',
  'nota.wizard.title': 'Lançamento de Notas',
  'nota.wizard.subtitle': 'Preencha os dados abaixo e avance pelos passos seguintes.',
  'nota.wizard.step.data': 'Dados da Pauta',
  'nota.wizard.step.grades': 'Notas dos Estudantes',
  'nota.field.evaluation': 'Avaliação',
  'nota.field.evaluation.placeholder': 'Seleccione uma avaliação',
  'nota.field.searchStudent.placeholder': 'Pesquisar estudante...',
  'nota.col.grade': 'Nota',
  'nota.col.gradePercent': 'Nota (%)',
  'nota.col.teacher': 'Professor',
  'nota.section.grades': 'Notas dos Estudantes',
  'nota.filter.allClasses': 'Todas as turmas',
  'nota.filter.status': 'Estado',
  'nota.filter.allStatus': 'Todos os estados',
  'nota.filter.period': 'Trimestre',
  'nota.filter.allPeriods': 'Todos os trimestres',
  'nota.filter.multiplePeriods': 'Vários',
  'nota.detail.degree': 'Grau',
  'nota.detail.degreeLevel.curso': 'Curso do Grau',
  'nota.detail.degreeLevel.classe': 'Classe do Grau',
  'nota.detail.degreeLevel.nivel': 'Nível do Grau',
  'nota.detail.teacherNotes': 'Notas do Professor',
  'nota.detail.notes': 'Observações',
  'class.evaluationDate': 'Data da Avaliação',
  'nota.hint.selectEvaluation.curso': 'Seleccione o curso, turma, disciplina e avaliação.',
  'nota.hint.selectEvaluation.classe': 'Seleccione a classe, turma, disciplina e avaliação.',
  'nota.hint.selectEvaluation.nivel': 'Seleccione o nível, turma, disciplina e avaliação.',
  'nota.hint.noGradebook': 'Ainda não existe uma pauta para esta combinação. Crie uma para começar a lançar notas.',
  'nota.hint.noGradebooks': 'Nenhuma pauta encontrada.',
  'nota.hint.noStudentsGraded': 'Nenhum estudante nesta pauta.',
  'nota.hint.gradebookExists': 'Já existe uma pauta para esta combinação. Avance para lançar as notas.',
  'nota.hint.gradedCount': '{graded}/{total} notas lançadas',
  'nota.action.createGradebook': 'Criar Pauta',
  'nota.action.createAnother': 'Lançar Outra Pauta',
  'nota.action.finalize': 'Finalizar',
  'nota.action.publish': 'Publicar',
  'nota.action.requestChange': 'Solicitar Alteração',
  'nota.action.authorizeChange': 'Autorizar Alteração',
  'nota.action.acceptChangeRequest': 'Aceitar Pedido',
  'nota.action.save': 'Salvar',
  'nota.action.edit': 'Editar',
  'nota.action.view': 'Visualizar',
  'nota.view.breadcrumb': 'Visualizar Pauta',
  'nota.view.notFound': 'Não foi possível carregar esta pauta. Volte à lista e tente novamente.',
  'nota.status.draft': 'Rascunho',
  'nota.status.finalized': 'Finalizada',
  'nota.status.published': 'Publicada',
  'nota.status.change': 'Alteração Solicitada',
  'nota.confirm.finalize': 'Ao finalizar, os estudantes sem nota lançada ficam automaticamente com 0. Deseja continuar?',
  'nota.confirm.finalizeTeacher': 'Ao finalizar, os estudantes sem nota lançada ficam automaticamente com 0. Depois de finalizada, esta pauta não pode ser editada. Deseja continuar?',
  'nota.success.gradebookCreated': 'Pauta criada com sucesso.',
  'nota.success.finalized': 'Pauta finalizada com sucesso.',
  'nota.success.published': 'Pauta publicada com sucesso.',
  'nota.success.changeRequested': 'Alteração solicitada com sucesso.',
  'nota.success.changeAuthorized': 'Pedido de alteração aceite com sucesso.',
  'nota.success.saved': 'Notas guardadas com sucesso.',
  'nota.error.invalidGrade': 'A nota deve estar entre 0 e 20.',
  'nota.error.invalidGradePercent': 'A nota deve estar entre 0 e 100.',
  'nota.error.create': 'Erro ao criar a pauta.',
  'nota.error.save': 'Erro ao guardar a nota.',
  'nota.error.finalize': 'Erro ao finalizar a pauta.',
  'nota.error.publish': 'Erro ao publicar a pauta.',
  'nota.error.change': 'Erro ao solicitar alteração.',
  'nota.error.authorizeChange': 'Erro ao autorizar alteração.',
  'nota.error.load': 'Erro ao carregar as pautas.',
  'nota.error.requiredFields.curso': 'Seleccione o curso, turma, disciplina e avaliação antes de avançar.',
  'nota.error.requiredFields.classe': 'Seleccione a classe, turma, disciplina e avaliação antes de avançar.',
  'nota.error.requiredFields.nivel': 'Seleccione o nível, turma, disciplina e avaliação antes de avançar.',

  'pauta.breadcrumb': 'Pautas',
  'pauta.field.class.placeholder': 'Seleccione uma turma',
  'pauta.col.total': 'Total',
  'pauta.col.graded': 'Notas Lançadas',
  'pauta.col.missing': 'Notas por Lançar',
  'pauta.filter.allSubjects': 'Todas as disciplinas',
  'pauta.hint.selectClass.curso': 'Seleccione o curso e a turma para ver as pautas.',
  'pauta.hint.selectClass.classe': 'Seleccione a classe e a turma para ver as pautas.',
  'pauta.hint.selectClass.nivel': 'Seleccione o nível e a turma para ver as pautas.',
  'pauta.hint.noData': 'Nenhuma pauta encontrada para esta turma.',
  'pauta.hint.noEvaluations': 'Nenhuma avaliação encontrada para esta disciplina.',
  'pauta.hint.missingEvaluations': 'Notas por lançar em: {names}.',
  'pauta.hint.noGradebook': 'Pauta não criada',
  'pauta.action.publish': 'Publicar',
  'pauta.action.export': 'Exportar',
  'pauta.action.exportAll': 'Exportar Todas as Pautas',
  'pauta.action.goToNotas': 'Gerir em Lista de Notas',
  'pauta.confirm.publish': 'Ao publicar, as notas desta disciplina/turma ficam visíveis. Deseja continuar?',
  'pauta.success.published': 'Pauta publicada com sucesso.',
  'pauta.error.load': 'Erro ao carregar as pautas.',
  'pauta.error.publish': 'Erro ao publicar a pauta.',
  'pauta.error.export': 'Erro ao exportar a pauta.',

  'boletim.breadcrumb': 'Boletim',
  'boletim.hint.notCambridge': 'O Boletim só está disponível para sucursais com o modelo Cambridge activo (Configurações > Pautas).',
  'boletim.hint.selectClass.curso': 'Seleccione o curso e a turma para ver o boletim.',
  'boletim.hint.selectClass.classe': 'Seleccione a classe e a turma para ver o boletim.',
  'boletim.hint.selectClass.nivel': 'Seleccione o nível e a turma para ver o boletim.',
  'boletim.hint.noStudents': 'Nenhum estudante encontrado para esta turma.',
  'boletim.col.exams': 'Exams',
  'boletim.col.progress': 'Progress Test',
  'boletim.col.coursework': 'Course work',
  'boletim.col.behaviour': 'Behaviour',
  'boletim.col.total': 'Total',
  'boletim.col.teacherComment': "Comentário do professor",
  'boletim.action.printPdf': 'Imprimir PDF',
  'boletim.error.load': 'Erro ao carregar o boletim.',
  'boletim.error.print': 'Erro ao gerar o PDF do boletim.',

  'config.breadcrumb': 'Configurações',
  'config.tab.multas': 'Multas',
  'config.tab.pagamentos': 'Pagamentos',
  'config.tab.pautas': 'Pautas',

  'config.multa.subtitle': 'Faixas de dias em atraso e a percentagem de multa aplicada em cada uma. As faixas devem cobrir os dias em sequência, sem sobreposição.',
  'config.multa.field.startDate': 'Dia inicial',
  'config.multa.field.endDate': 'Dia final',
  'config.multa.field.percentage': 'Percentagem',
  'config.multa.action.add': 'Adicionar',
  'config.multa.hint.empty': 'Ainda não existem faixas de multa configuradas.',
  'config.multa.error.load': 'Erro ao carregar as configurações de multa.',
  'config.multa.error.requiredFields': 'Preencha o dia inicial, o dia final e a percentagem.',
  'config.multa.error.save': 'Erro ao gravar a configuração de multa.',
  'config.multa.error.delete': 'Erro ao eliminar a configuração de multa.',
  'config.multa.success.created': 'Faixa de multa criada com sucesso.',
  'config.multa.success.updated': 'Faixa de multa actualizada com sucesso.',
  'config.multa.success.deleted': 'Faixa de multa eliminada com sucesso.',

  'config.pagamento.subtitle': 'Regras gerais de vencimento das mensalidades desta sucursal.',
  'config.pagamento.field.paymentStartDay': 'Dia de início do vencimento',
  'config.pagamento.field.paymentEndDay': 'Dia limite de pagamento',
  'config.pagamento.field.initialMonth': 'Mês de início do ano lectivo',
  'config.pagamento.field.smsSenderID': 'Remetente de SMS',
  'config.pagamento.error.load': 'Erro ao carregar a configuração de pagamentos.',
  'config.pagamento.error.save': 'Erro ao gravar a configuração de pagamentos.',
  'config.pagamento.success.saved': 'Configuração de pagamentos gravada com sucesso.',

  'config.pauta.subtitle': 'Controle a visualização de Pautas pelos estudantes no WhatsApp. Estas opções aplicam-se a todas as Pautas desta sucursal de uma só vez.',
  'config.pauta.field.visivel': 'Permitir visualização de Pautas no WhatsApp',
  'config.pauta.field.visivel.hint': 'Quando desligado, nenhum estudante desta sucursal consegue ver as suas Pautas pelo WhatsApp — recebem uma mensagem de indisponibilidade.',
  'config.pauta.field.bloqueiaAtraso': 'Bloquear estudantes com pagamentos em atraso',
  'config.pauta.field.bloqueiaAtraso.hint': 'Quando ligado, um estudante com mensalidades em atraso não consegue ver a Pauta até regularizar. Quando desligado, a Pauta fica visível mesmo com pagamentos em atraso.',
  'config.pauta.field.cambridge': 'Modelo Cambridge',
  'config.pauta.field.cambridge.hint': 'Activa o boletim Cambridge Assessment International Education (3 categorias ponderadas + Behaviour, notas em %, letras A*-U) em todos os ecrãs de Gestão Académica desta sucursal, em vez do modelo nacional (notas 0-20).',
  'config.pauta.error.load': 'Erro ao carregar a configuração de pautas.',
  'config.pauta.error.save': 'Erro ao gravar a configuração de pautas.',
  'config.pauta.success.saved': 'Configuração de pautas gravada com sucesso.',

  'auditoria.breadcrumb': 'Auditoria',
  'auditoria.field.dateFrom': 'De',
  'auditoria.field.dateTo': 'Até',
  'auditoria.field.operation': 'Operação',
  'auditoria.field.entity': 'Entidade',
  'auditoria.field.userName': 'Utilizador',
  'auditoria.field.userName.placeholder': 'Nome do utilizador',
  'auditoria.filter.allOperations': 'Todas',
  'auditoria.filter.allEntities': 'Todas',
  'auditoria.operation.insert': 'Inserção',
  'auditoria.operation.update': 'Actualização',
  'auditoria.operation.delete': 'Remoção',
  'auditoria.action.search': 'Pesquisar',
  'auditoria.trail.title': 'Trilha de Auditoria',
  'auditoria.hint.selectRange': 'Seleccione um período e pesquise para ver a trilha de auditoria.',
  'auditoria.hint.empty': 'Nenhum registo encontrado para os filtros seleccionados.',
  'auditoria.warning.dateRange': 'Seleccione um intervalo de datas válido.',
  'auditoria.error.load': 'Erro ao carregar a trilha de auditoria.',
  'auditoria.col.dateTime': 'Data / Hora',
  'auditoria.col.userName': 'Utilizador',
  'auditoria.col.entity': 'Entidade',
  'auditoria.col.operation': 'Operação',
  'auditoria.col.action': 'Acção',
  'auditoria.diff.fieldChanged': 'campo alterado',
  'auditoria.diff.fieldsChanged': 'campos alterados',
  'auditoria.diff.before': 'Antes',
  'auditoria.diff.after': 'Depois',
  'auditoria.detail.noInsertData': 'Sem dados de inserção',
  'auditoria.detail.noBasicFields': 'Dados técnicos — sem campos básicos para exibir',
  'auditoria.detail.insertedData': 'Dados do registo criado',
  'auditoria.detail.noDeleteData': 'Sem dados do registo removido',
  'auditoria.detail.noFields': 'Sem dados para exibir',
  'auditoria.detail.deletedData': 'Dados do registo eliminado',
  'auditoria.detail.unknownOperation': 'Tipo de operação desconhecido',

  'renovacao.breadcrumb': 'Renovação de Inscrição',
  'renovacao.subtitle': 'Estudantes de anos lectivos anteriores que ainda não têm inscrição para o ano actual.',
  'renovacao.stat.pending': 'Pendentes de Renovação',
  'renovacao.stat.renewedSession': 'Renovadas Nesta Sessão',
  'renovacao.field.filterYear': 'Ano Lectivo Anterior',
  'renovacao.field.sucursal': 'Sucursal',
  'renovacao.info.transfer.title': 'Transferência de Sucursal',
  'renovacao.info.transfer': 'Esta renovação irá transferir o estudante para a sucursal "{sucursal}", no ano lectivo {year}.',
  'renovacao.filter.level.placeholder.curso': 'Todos os cursos',
  'renovacao.filter.level.placeholder.classe': 'Todas as classes',
  'renovacao.filter.level.placeholder.nivel': 'Todos os níveis',
  'renovacao.field.search.placeholder': 'Pesquisar por nome ou código...',
  'renovacao.col.previousLevel.curso': 'Curso Anterior',
  'renovacao.col.previousLevel.classe': 'Classe Anterior',
  'renovacao.col.previousLevel.nivel': 'Nível Anterior',
  'renovacao.col.lastRegistration': 'Última Inscrição',
  'renovacao.col.year': 'Ano',
  'renovacao.action.renew': 'Renovar',
  'renovacao.action.review': 'Rever Dados',
  'renovacao.action.back': 'Voltar',
  'renovacao.action.confirm': 'Confirmar Renovação',
  'renovacao.action.viewDetails': 'Ver detalhes',
  'renovacao.confirm.title': 'Confirme os Dados da Renovação',
  'renovacao.confirm.hint': 'Reveja atentamente os dados abaixo. Ao confirmar, a inscrição será criada.',
  'renovacao.hint.noStudents': 'Todos os estudantes já têm inscrição para este ano lectivo. 🎉',
  'renovacao.empty.filtered': 'Nenhum estudante corresponde aos filtros seleccionados.',
  'renovacao.modal.title': 'Renovar Inscrição',
  'renovacao.modal.subtitle': 'Reveja os dados e confirme a renovação para o novo ano lectivo.',
  'renovacao.section.previous': 'Situação Actual',
  'renovacao.section.newRegistration': 'Nova Matrícula',
  'renovacao.section.guardian': 'Dados do Encarregado de Educação',
  'renovacao.field.discount': 'Desconto',
  'renovacao.field.discountTarget': 'Aplicar desconto a',
  'renovacao.field.discountTarget.registration': 'Valor da Renovação',
  'renovacao.field.discountTarget.monthly': 'Propinas',
  'renovacao.field.discountTarget.both': 'Ambos',
  'renovacao.summary.monthlyAfterDiscount': 'Mensalidade com Desconto',
  'renovacao.field.registrationValue': 'Valor de Inscrição',
  'renovacao.field.monthlyPayment': 'Mensalidade',
  'renovacao.summary.baseValue': 'Valor Base de Inscrição',
  'renovacao.summary.discountApplied': 'Desconto Aplicado',
  'renovacao.summary.total': 'Total a Pagar',
  'renovacao.payment.title': 'Pagamento da Renovação',
  'renovacao.payment.subtitle':
    'Método de pagamento e valor pago da taxa de Renovação. Esta secção não inclui a mensalidade.',
  'renovacao.detail.lastMonthly': 'Mensalidade Anterior',
  'renovacao.success.renewed': 'Inscrição renovada com sucesso.',
  'renovacao.error.requiredFields.curso': 'Seleccione o curso.',
  'renovacao.error.requiredFields.classe': 'Seleccione a classe.',
  'renovacao.error.requiredFields.nivel': 'Seleccione o nível.',
  'renovacao.error.requiredGuardian': 'Preencha os dados obrigatórios do encarregado de educação.',
  'renovacao.error.invalidContact': 'O contacto do encarregado deve ter 9 dígitos.',
  'renovacao.error.renew': 'Erro ao renovar a inscrição.',
  'renovacao.error.load': 'Erro ao carregar os estudantes.',
  'renovacao.duplicate.checking': 'A verificar inscrições existentes...',
  'renovacao.error.duplicateYear.title': 'Inscrição já existe',
  'renovacao.error.duplicateYear': 'Este estudante já tem uma inscrição activa para o ano {year}. Não é possível criar uma segunda inscrição.',
  'renovacao.info.duplicateAllowed.title': 'Múltiplas inscrições (Global Academy)',
  'renovacao.info.duplicateAllowed': 'Este estudante já tem outra inscrição activa noutro curso para este ano. Esta sucursal permite inscrições em cursos diferentes no mesmo ano.',
  'renovacao.documento.title': 'Comprovativo de Renovação — {name}',

  // "classe.*" — screens behind the dynamic Classes/Cursos/Níveis menu
  // (see src/utils/classesLabels.js). `{term}` is filled in at the call site
  // with the current sucursal's singular vocabulary ("Curso"/"Classe"/"Nível"),
  // same pattern as despesa.list.print.title's {month}/{year}.
  'classe.list.subtitle': 'Consulte, edite e elimine os registos cadastrados.',
  'classe.list.add': 'Adicionar {term}',
  'classe.breadcrumb.create': 'Cadastrar {term}',
  'classe.wizard.title': 'Cadastrar {term}',
  'classe.wizard.subtitle': 'Preencha os dados abaixo e avance pelos passos seguintes.',
  'classe.wizard.step.data': 'Dados',
  'classe.wizard.step.confirm': 'Confirmação',
  'classe.field.description': 'Descrição',
  'classe.field.codeDescription': 'Código - Descrição',
  'classe.field.duration': 'Duração',
  'classe.field.duration.months': 'Meses',
  'classe.field.registrationValue': 'Valor de Inscrição',
  'classe.field.renewalValue': 'Valor de Renovação',
  'classe.field.monthlyPayment': 'Mensalidade',
  'classe.field.specialHourMonthlyValue': 'Mensalidade Horário Especial (7h - 15h)',
  'classe.confirm.description': 'Confirme os dados abaixo antes de submeter.',
  'classe.action.edit': 'Editar {term}',
  'classe.action.createAnother': 'Cadastrar Outro',
  'classe.hint.noItems': 'Nenhum registo cadastrado.',
  'classe.confirm.delete': 'Tem a certeza que deseja eliminar "{name}"?',
  'classe.success.created': 'Registo criado com sucesso.',
  'classe.success.updated': 'Registo actualizado com sucesso.',
  'classe.success.deleted': 'Registo eliminado com sucesso.',
  'classe.error.requiredFields': 'Preencha a descrição, duração, valor de inscrição e mensalidade.',
  'classe.error.create': 'Erro ao criar o registo.',
  'classe.error.update': 'Erro ao actualizar o registo.',
  'classe.error.delete': 'Erro ao eliminar o registo.',
  'classe.error.load': 'Erro ao carregar os registos.',

  'rendimento.breadcrumb': 'Rendimento Pedagógico',
  'rendimento.field.class.placeholder': 'Seleccione uma turma',
  'rendimento.hint.selectClass': 'Seleccione uma turma para ver o rendimento pedagógico.',
  'rendimento.hint.noGrades': 'Ainda não há notas finalizadas/publicadas para esta turma.',
  'rendimento.col.subjectsCount': 'Nº de Avaliações',
  'rendimento.col.average': 'Média Geral',
  'rendimento.col.classification': 'Classificação',
  'rendimento.error.load': 'Erro ao carregar o rendimento pedagógico.',
  'classificacao.good': 'Bom',
  'classificacao.sufficient': 'Suficiente',
  'classificacao.insufficient': 'Insuficiente',

  'produto.breadcrumb': 'Produtos',
  'produto.breadcrumb.create': 'Cadastrar Produto',
  'produto.breadcrumb.list': 'Lista de Produtos',
  'produto.list.subtitle': 'Consulte os produtos cadastrados e adicione novos.',
  'produto.list.add': 'Adicionar Produto',
  'produto.list.search.placeholder': 'Pesquisar por nome',
  'produto.list.total': 'produto(s)',
  'produto.wizard.title': 'Cadastrar Produto',
  'produto.wizard.subtitle': 'Preencha os dados abaixo e avance pelos passos seguintes.',
  'produto.wizard.step.data': 'Dados do Produto',
  'produto.wizard.step.confirm': 'Confirmação',
  'produto.field.name': 'Nome do Produto',
  'produto.field.baseUnit': 'Unidade Base',
  'produto.field.packageType': 'Tipo de Embalagem',
  'produto.field.unitPrice': 'Preço Unitário',
  'produto.field.packagePrice': 'Preço por Embalagem',
  'produto.field.quantityPerPackage': 'Quantidade por Embalagem',
  'produto.col.available': 'Qtd. Disponível',
  'produto.section.list': 'Lista de Produtos',
  'produto.confirm.description': 'Confirme os dados abaixo antes de submeter.',
  'produto.action.createAnother': 'Cadastrar Outro Produto',
  'produto.hint.noProducts': 'Nenhum produto encontrado.',
  'produto.success.created': 'Produto criado com sucesso.',
  'produto.error.requiredFields': 'Preencha o nome e a unidade base.',
  'produto.error.create': 'Erro ao criar o produto.',
  'produto.error.load': 'Erro ao carregar os produtos.',

  'despesa.breadcrumb': 'Despesas',
  'despesa.breadcrumb.create': 'Registar Despesa',
  'despesa.breadcrumb.list': 'Lista de Despesas',
  'despesa.list.subtitle': 'Consulte, filtre e elimine as despesas registadas.',
  'despesa.list.add': 'Adicionar Despesa',
  'despesa.list.total': 'despesa(s)',
  'despesa.list.action.remove': 'Eliminar',
  'despesa.list.confirm.remove': 'Tem a certeza que deseja eliminar esta despesa?',
  'despesa.list.remove.success': 'Despesa eliminada com sucesso',
  'despesa.list.remove.error': 'Erro ao eliminar a despesa',
  'despesa.list.print': 'Imprimir Relatório',
  'despesa.list.print.title': 'Relatório de Despesas — {month} de {year}',
  'despesa.list.print.title.range': 'Relatório de Despesas — {startDate} a {endDate}',
  'despesa.list.print.error': 'Erro ao imprimir o Relatório de Despesas',
  'despesa.stat.count': 'Despesas',
  'despesa.stat.totalValue': 'Valor Total',
  'despesa.stat.pending': 'Pendentes',
  'despesa.status.approved': 'Aprovado',
  'despesa.status.pending': 'Pendente',
  'despesa.status.rejected': 'Rejeitado',
  'despesa.wizard.title': 'Registar Despesa',
  'despesa.wizard.subtitle': 'Preencha os dados abaixo e avance pelos passos seguintes.',
  'despesa.wizard.step.data': 'Dados da Despesa',
  'despesa.wizard.step.confirm': 'Confirmação',
  'despesa.field.name': 'Nome / Designação',
  'despesa.field.type': 'Tipo de Despesa',
  'despesa.kind.fixed': 'Fixa',
  'despesa.kind.variable': 'Variável',
  'despesa.field.category': 'Categoria',
  'despesa.field.category.placeholder': 'Seleccione a categoria',
  'despesa.field.category.newOption': '+ Nova categoria',
  'despesa.field.category.new.placeholder': 'Nome da nova categoria',
  'despesa.field.fund': 'Fundo de Despesa',
  'despesa.field.fund.placeholder': 'Seleccione o fundo',
  'despesa.field.fund.newOption': '+ Novo fundo',
  'despesa.field.fund.new.placeholder': 'Nome do novo fundo',
  'despesa.field.items': 'Itens da Despesa',
  'despesa.field.items.description': 'Descrição',
  'despesa.field.items.price': 'Preço',
  'despesa.field.items.add': '+ Adicionar item',
  'despesa.field.items.remove': 'Remover',
  'despesa.field.items.total': 'Total',
  'despesa.field.value': 'Valor',
  'despesa.field.date': 'Data',
  'despesa.field.year': 'Ano',
  'despesa.field.month': 'Mês',
  'despesa.field.startDate': 'Data de Início',
  'despesa.field.endDate': 'Data de Fim',
  'despesa.list.filter.clear': 'Limpar Filtros',
  'despesa.field.notes': 'Notas',
  'despesa.section.list': 'Lista de Despesas',
  'despesa.list.col.name': 'Nome',
  'despesa.list.col.category': 'Categoria',
  'despesa.list.col.fund': 'Fundo',
  'despesa.list.col.kind': 'Tipo',
  'despesa.confirm.description': 'Confirme os dados abaixo antes de submeter.',
  'despesa.action.createAnother': 'Registar Outra Despesa',
  'despesa.hint.noExpenses': 'Nenhuma despesa encontrada.',
  'despesa.success.created': 'Despesa registada com sucesso.',
  'despesa.success.typeCreated': 'Categoria de despesa criada com sucesso.',
  'despesa.success.fundCreated': 'Fundo de despesa criado com sucesso.',
  'despesa.error.requiredFields': 'Preencha o tipo, nome, categoria, fundo e data da despesa.',
  'despesa.error.requiredValue': 'Indique o valor da despesa.',
  'despesa.error.requiredItems': 'Adicione pelo menos um item com descrição e preço.',
  'despesa.error.create': 'Erro ao registar a despesa.',
  'despesa.error.createType': 'Erro ao criar a categoria.',
  'despesa.error.categoryExists': 'Já existe uma categoria com esse nome.',
  'despesa.error.createFund': 'Erro ao criar o fundo.',
  'despesa.error.fundExists': 'Já existe um fundo com esse nome.',
  'despesa.error.load': 'Erro ao carregar as despesas.',

  'consumo.breadcrumb': 'Controlo de Consumo',
  'consumo.breadcrumb.create': 'Registar Consumo',
  'consumo.breadcrumb.list': 'Controlo de Consumo',
  'consumo.list.subtitle': 'Consulte o histórico de consumo de produtos e registe novos.',
  'consumo.list.add': 'Adicionar Consumo',
  'consumo.wizard.title': 'Registar Consumo',
  'consumo.wizard.subtitle': 'Preencha os dados abaixo e avance pelos passos seguintes.',
  'consumo.wizard.step.data': 'Dados do Consumo',
  'consumo.wizard.step.confirm': 'Confirmação',
  'consumo.field.product': 'Produto',
  'consumo.field.quantity': 'Quantidade',
  'consumo.field.unitType': 'Tipo de Unidade',
  'consumo.field.date': 'Data',
  'consumo.unitType.package': 'Embalagem',
  'consumo.unitType.base': 'Unidade Base',
  'consumo.hint.available': 'Disponível: {qty}',
  'consumo.col.totalConsumed': 'Total Consumido',
  'consumo.col.currentStock': 'Stock Actual',
  'consumo.section.list': 'Histórico de Consumo',
  'consumo.confirm.description': 'Confirme os dados abaixo antes de submeter.',
  'consumo.action.createAnother': 'Registar Outro Consumo',
  'consumo.hint.noConsumptions': 'Nenhum registo de consumo encontrado.',
  'consumo.success.created': 'Consumo registado com sucesso.',
  'consumo.error.requiredFields': 'Seleccione o produto e a quantidade.',
  'consumo.error.create': 'Erro ao registar o consumo.',
  'consumo.error.load': 'Erro ao carregar o histórico de consumo.',

  'artigo.breadcrumb': 'Cadastrar Artigos',
  'artigo.wizard.title': 'Cadastrar Artigo',
  'artigo.wizard.subtitle': 'Preencha os dados abaixo e avance pelos passos seguintes.',
  'artigo.wizard.step.data': 'Dados do Artigo',
  'artigo.wizard.step.confirm': 'Confirmação',
  'artigo.field.name': 'Nome do Artigo',
  'artigo.field.gender': 'Género',
  'artigo.field.size': 'Tamanho',
  'artigo.field.color': 'Cor',
  'artigo.field.price': 'Preço Unitário',
  'artigo.field.stock': 'Quantidade em Stock',
  'artigo.col.available': 'Qtd. Disponível',
  'artigo.col.sold': 'Qtd. Vendida',
  'artigo.section.list': 'Lista de Artigos',
  'artigo.confirm.description': 'Confirme os dados abaixo antes de submeter.',
  'artigo.action.createAnother': 'Cadastrar Outro Artigo',
  'artigo.hint.noArticles': 'Nenhum artigo encontrado.',
  'artigo.success.created': 'Artigo cadastrado com sucesso.',
  'artigo.error.requiredFields': 'Preencha o nome e o tamanho do artigo.',
  'artigo.error.create': 'Erro ao cadastrar o artigo.',
  'artigo.error.load': 'Erro ao carregar os artigos.',

  'stock.breadcrumb': 'Stock de Uniformes',
  'stock.action.addStock': 'Abastecer Stock',
  'stock.field.quantityToAdd': 'Quantidade a Adicionar',
  'stock.success.added': 'Stock abastecido com sucesso.',
  'stock.error.invalidQuantity': 'Indique uma quantidade válida.',
  'stock.error.add': 'Erro ao abastecer o stock.',

  'venda.breadcrumb': 'Vendas de Uniformes',
  'venda.wizard.title': 'Registar Venda',
  'venda.wizard.subtitle': 'Preencha os dados abaixo e avance pelos passos seguintes.',
  'venda.wizard.step.data': 'Dados da Venda',
  'venda.wizard.step.confirm': 'Confirmação',
  'venda.field.article': 'Artigo',
  'venda.field.quantity': 'Quantidade',
  'venda.field.status': 'Estado',
  'venda.field.total': 'Total',
  'venda.status.delivered': 'Entregue',
  'venda.status.notDelivered': 'Não Entregue',
  'venda.section.list': 'Vendas Recentes',
  'venda.confirm.description': 'Confirme os dados abaixo antes de submeter.',
  'venda.action.createAnother': 'Registar Outra Venda',
  'venda.hint.noSales': 'Nenhuma venda encontrada.',
  'venda.success.created': 'Venda registada com sucesso.',
  'venda.error.requiredFields': 'Seleccione o artigo e a quantidade.',
  'venda.error.insufficientStock': 'Quantidade insuficiente em stock.',
  'venda.error.create': 'Erro ao registar a venda.',
  'venda.error.load': 'Erro ao carregar as vendas.',

  'taxa.breadcrumb': 'Taxas e Emolumentos',
  'taxa.breadcrumb.create': 'Cadastrar Taxa/Emolumento',
  'taxa.breadcrumb.list': 'Lista de Taxas e Emolumentos',
  'taxa.list.subtitle': 'Consulte as taxas e emolumentos cadastrados e adicione novos.',
  'taxa.list.add': 'Adicionar Taxa',
  'taxa.wizard.title': 'Cadastrar Taxa/Emolumento',
  'taxa.wizard.subtitle': 'Preencha os dados abaixo e avance pelos passos seguintes.',
  'taxa.wizard.step.data': 'Dados da Taxa',
  'taxa.wizard.step.confirm': 'Confirmação',
  'taxa.field.name': 'Nome da Taxa',
  'taxa.field.value': 'Valor',
  'taxa.field.course.curso': 'Curso',
  'taxa.field.course.classe': 'Classe',
  'taxa.field.course.nivel': 'Nível',
  'taxa.field.course.allLevels.curso': 'Todos os cursos',
  'taxa.field.course.allLevels.classe': 'Todas as classes',
  'taxa.field.course.allLevels.nivel': 'Todos os níveis',
  'taxa.field.periodicity': 'Periodicidade',
  'taxa.field.recorrency': 'Recorrência',
  'taxa.periodicity.once': 'Apenas uma vez',
  'taxa.periodicity.recurring': 'Recorrente',
  'taxa.section.list': 'Lista de Taxas e Emolumentos',
  'taxa.confirm.description': 'Confirme os dados abaixo antes de submeter.',
  'taxa.action.createAnother': 'Cadastrar Outra Taxa',
  'taxa.hint.noTaxes': 'Nenhuma taxa encontrada.',
  'taxa.success.created': 'Taxa criada com sucesso.',
  'taxa.success.activated': 'Taxa activada com sucesso.',
  'taxa.success.deactivated': 'Taxa desactivada com sucesso.',
  'taxa.success.removed': 'Taxa removida com sucesso.',
  'taxa.error.requiredFields': 'Preencha o nome e o valor da taxa.',
  'taxa.error.create': 'Erro ao criar a taxa.',
  'taxa.error.toggle': 'Erro ao alterar o estado da taxa.',
  'taxa.error.load': 'Erro ao carregar as taxas.',
  'taxa.error.remove': 'Erro ao remover a taxa. Verifique se já existem alunos associados a ela.',
  'taxa.confirm.remove': 'Tem a certeza que deseja remover esta taxa? Esta acção não pode ser desfeita.',

  'extra.breadcrumb': 'Extras',
  'extra.breadcrumb.create': 'Cadastrar Extra',
  'extra.breadcrumb.list': 'Lista de Extras',
  'extra.list.subtitle': 'Consulte os extras cadastrados e adicione novos.',
  'extra.list.add': 'Adicionar Extra',
  'extra.wizard.title': 'Cadastrar Extra',
  'extra.wizard.subtitle': 'Preencha os dados abaixo e avance pelos passos seguintes.',
  'extra.wizard.step.data': 'Dados do Extra',
  'extra.wizard.step.confirm': 'Confirmação',
  'extra.field.name': 'Nome do Extra',
  'extra.field.registrationAmount': 'Valor de Inscrição',
  'extra.field.recuringAmount': 'Valor Recorrente (Mensal)',
  'extra.section.list': 'Lista de Extras',
  'extra.confirm.description': 'Confirme os dados abaixo antes de submeter.',
  'extra.action.createAnother': 'Cadastrar Outro Extra',
  'extra.hint.noExtras': 'Nenhum extra encontrado.',
  'extra.success.created': 'Extra criado com sucesso.',
  'extra.error.requiredFields': 'Preencha o nome e o valor recorrente.',
  'extra.error.create': 'Erro ao criar o extra.',
  'extra.error.load': 'Erro ao carregar os extras.',

  'relatorioDividas.breadcrumb': 'Relatório de Dívidas',
  'relatorioDividas.field.type': 'Tipo',
  'relatorioDividas.field.months': 'Meses',
  'relatorioDividas.field.months.placeholder': 'Seleccione os meses (vazio = todos)',
  'relatorioDividas.type.propinas': 'Propinas',
  'relatorioDividas.type.extras': 'Extras',
  'relatorioDividas.action.generate': 'Gerar Relatório',
  'relatorioDividas.hint.allMonths': 'Se não seleccionar nenhum mês, o relatório inclui o ano inteiro.',
  'relatorioDividas.documento.title': 'Relatório de Dívidas — {period}',
  'relatorioDividas.error.generate': 'Erro ao gerar o relatório.',

  'relatorioPagamentos.breadcrumb': 'Relatório de Pagamentos',
  'relatorioPagamentos.field.month': 'Mês',
  'relatorioPagamentos.type.propinasExtra': 'Propinas + Extras',
  'relatorioPagamentos.field.day': 'Dia',
  'relatorioPagamentos.field.startDate': 'Data Início',
  'relatorioPagamentos.field.endDate': 'Data Fim',
  'relatorioPagamentos.day.none': 'Selecionar...',
  'relatorioPagamentos.day.today': 'Hoje',
  'relatorioPagamentos.day.yesterday': 'Ontem',
  'relatorioPagamentos.day.week': 'Esta Semana',
  'relatorioPagamentos.hint.dateFilter': 'Data Início e Data Fim são preenchidas automaticamente a partir do Dia ou do Mês/Ano, mas pode editá-las para definir um intervalo personalizado.',
  'relatorioPagamentos.action.generatePdf': 'Gerar PDF',
  'relatorioPagamentos.stat.studentsPaid': 'Estudantes Pagos',
  'relatorioPagamentos.stat.studentsUnpaid': 'Estudantes por Pagar',
  'relatorioPagamentos.stat.paidValue': 'Valor Pago',
  'relatorioPagamentos.stat.unpaidValue': 'Valor em Dívida',
  'relatorioPagamentos.hint.noData': 'Sem dados para o período seleccionado.',
  'relatorioPagamentos.documento.title': 'Relatório de Pagamentos — {month} de {year}',
  'relatorioPagamentos.documento.titleRange': 'Relatório de Pagamentos — {startDate} a {endDate}',
  'relatorioPagamentos.documento.titleDay': 'Relatório de Pagamentos — {day}',
  'relatorioPagamentos.error.generate': 'Erro ao gerar o relatório.',
  'relatorioPagamentos.error.load': 'Erro ao carregar os dados do relatório.',
  'relatorioPagamentos.error.dateRange': 'Indique a Data Início e a Data Fim.',

  'pagamentosEfectuados.breadcrumb': 'Pagamentos Efectuados',
  'pagamentosEfectuados.type.propinas': 'Propinas',
  'pagamentosEfectuados.type.extrasTodos': 'Todos os Extras',
  'pagamentosEfectuados.type.extrasEspecificos': 'Extras Específicos',
  'pagamentosEfectuados.type.propinasExtras': 'Propinas + Extras',
  'pagamentosEfectuados.type.taxasTodas': 'Todas as Taxas',
  'pagamentosEfectuados.type.taxasEspecificas': 'Taxas Específicas',
  'pagamentosEfectuados.field.extras': 'Extras',
  'pagamentosEfectuados.field.extras.placeholder': 'Seleccione os extras (vazio = todos)',
  'pagamentosEfectuados.field.taxas': 'Taxas',
  'pagamentosEfectuados.field.taxas.placeholder': 'Seleccione as taxas (vazio = todas)',
  'pagamentosEfectuados.field.allMonthlyPaid': 'Com Todas as Mensalidades Pagas',
  'pagamentosEfectuados.action.generate': 'Gerar Relatório',
  'pagamentosEfectuados.action.consult': 'Consultar',
  'pagamentosEfectuados.documento.title': 'Pagamentos Efectuados — {period}',
  'pagamentosEfectuados.error.generate': 'Erro ao gerar o relatório.',
  'pagamentosEfectuados.error.list': 'Erro ao consultar os estudantes.',
  'pagamentosEfectuados.list.count': '{count} estudante(s)',
  'pagamentosEfectuados.list.totalPaid': 'Total Pago',
  'pagamentosEfectuados.list.empty': 'Nenhum estudante encontrado para os filtros seleccionados.',

  'perfis.breadcrumb.list': 'Perfis e Permissões',
  'perfis.breadcrumb.create': 'Criar Perfil',
  'perfis.action.create': 'Novo Perfil',
  'perfis.action.edit': 'Editar Perfil',
  'perfis.action.selectAll': 'Seleccionar tudo',
  'perfis.action.clearAll': 'Limpar',
  'perfis.field.name': 'Nome do Perfil',
  'perfis.field.name.placeholder': 'Ex.: Coordenador Pedagógico',
  'perfis.field.permissions': 'Funcionalidades',
  'perfis.field.permissions.placeholder': 'Seleccione as funcionalidades...',
  'perfis.col.name': 'Nome',
  'perfis.col.permissionsCount': 'Nº de Funcionalidades',
  'perfis.col.status': 'Estado',
  'perfis.col.actions': 'Acções',
  'perfis.badge.system': 'Protegido',
  'perfis.permissions.all': 'Todas',
  'perfis.hint.noProfiles': 'Ainda não existem perfis criados.',
  'perfis.hint.superAdminNote': 'Este é um perfil protegido do sistema, com acesso total a todas as funcionalidades. As permissões não podem ser alteradas.',
  'perfis.confirm.deactivate': 'Tem a certeza que deseja desactivar o perfil "{name}"?',
  'perfis.success.created': 'Perfil criado com sucesso.',
  'perfis.success.updated': 'Perfil actualizado com sucesso.',
  'perfis.success.deactivated': 'Perfil desactivado com sucesso.',
  'perfis.error.load': 'Erro ao carregar os perfis.',
  'perfis.error.save': 'Erro ao guardar o perfil.',
  'perfis.error.deactivate': 'Erro ao desactivar o perfil.',
  'perfis.error.nameRequired': 'Indique o nome do perfil.',

  // Labels do menu lateral (sidebar) — chaves alinhadas com os
  // permissionCode/key de src/config/menuConfig.js.
  'menu.dashboard.view': 'Dashboard',
  'menu.funcionarios': 'Funcionários',
  'menu.funcionarios.cadastrar': 'Cadastrar Funcionário',
  'menu.funcionarios.lista': 'Funcionários',
  'menu.professores': 'Professores',
  'menu.professores.cadastrar': 'Cadastrar Professor',
  'menu.professores.lista': 'Professores',
  'menu.utilizadores': 'Utilizadores e Perfis',
  'menu.utilizadores.cadastrar': 'Cadastrar Utilizador',
  'menu.utilizadores.lista': 'Utilizadores',
  'menu.utilizadores.perfis': 'Perfis e Permissões',
  'menu.estudantes': 'Estudantes',
  'menu.estudantes.cadastrar': 'Cadastrar Estudante',
  'menu.estudantes.activos': 'Estudantes Activos',
  'menu.estudantes.inactivos': 'Estudantes Inactivos',
  'menu.estudantes.nao_inscritos': 'Renovação de Inscrição',
  'menu.estudantes.notificacoes': 'Notificações',
  'menu.presencas': 'Presenças',
  'menu.presencas.colaboradores': 'Presenças Colaboradores',
  'menu.presencas.estudantes': 'Presenças Estudantes',
  'menu.pagamentos': 'Pagamentos',
  'menu.pagamentos.propinas': 'Propinas',
  'menu.pagamentos.extras': 'Extras',
  'menu.pagamentos.taxas': 'Taxas e Emolumentos',
  'menu.pagamentos.facturacao_agregada': 'Facturação Agregada',
  'menu.configuracoes.settings': 'Configurações',
  'menu.configuracoes.gerais': 'Configurações Gerais',
  'menu.configuracoes.auditoria': 'Auditoria',
  'menu.configuracoes.listaCursos.curso': 'Cursos',
  'menu.configuracoes.listaCursos.classe': 'Classes',
  'menu.configuracoes.listaCursos.nivel': 'Níveis',
  'menu.despesas': 'Custos e Despesas',
  'menu.despesas.consumo': 'Consumo',
  'menu.despesas.produtos': 'Produtos',
  'menu.despesas.lista': 'Despesas',
  'menu.uniformes': 'Uniformes',
  'menu.uniformes.cadastrar': 'Cadastrar Artigos',
  'menu.uniformes.stock': 'Stock',
  'menu.uniformes.vendas': 'Vendas',
  // Vocabulary for ListaClassesPage/CadastrarClassePage and their layers
  // (now linked from Configurações > "Cursos", not their own
  // sidebar group) — MasterLayout used to swap these in for that group's
  // label; getClassesLabels() (src/utils/classesLabels.js) still picks one
  // of the 3 sets below for those pages' breadcrumb/heading text.
  'menu.classes.cursos.submenu': 'Cursos',
  'menu.classes.cursos.singular': 'Curso',
  'menu.classes.classes.submenu': 'Classes',
  'menu.classes.classes.singular': 'Classe',
  'menu.classes.niveis.submenu': 'Níveis',
  'menu.classes.niveis.singular': 'Nível',
  'menu.relatorios': 'Relatórios',
  'menu.relatorios.pagamentos': 'Relatório de Pagamentos',
  'menu.relatorios.dividas': 'Relatório de Dívidas',
  'menu.relatorios.pagamentosEfectuados': 'Pagamentos Efectuados',
  'menu.turmas': 'Turmas',
  'menu.turmas.criar': 'Criar Turmas',
  'menu.turmas.lista': 'Turmas',
  'menu.academico': 'Gestão Académica',
  'menu.academico.disciplinas': 'Disciplinas',
  'menu.academico.avaliacoes': 'Avaliações',
  'menu.academico.lancamento_notas': 'Lançamento de Notas',
  'menu.academico.lista_notas': 'Notas',
  'menu.academico.pautas': 'Pautas',
  'menu.academico.boletim': 'Boletim',
  'menu.academico.rendimento_pedagogico': 'Rendimento Pedagógico',

  // Cabeçalho / layout
  'header.search.placeholder': 'Pesquisar',
  'header.notifications.title': 'Notificações',
  'header.notifications.empty': 'Sem notificações novas.',
  'header.profile.myProfile': 'Meu Perfil',
  'header.profile.logout': 'Sair',
  'footer.copyright': '© {year} SGE-PRO. Todos os Direitos Reservados.',
  'footer.developedBy': 'Desenvolvido pela',
  'network.offline.banner': 'Está offline. As acções estão bloqueadas até a ligação à internet ser restabelecida.',
  'auth.session.expired.inactivity': 'Sessão terminada por inactividade. Por favor, entre novamente.',

  // Página inicial (Dashboard)
  'dashboard.loading': 'A carregar...',
  'dashboard.today': 'Hoje',
  'dashboard.total': 'Total',
  'dashboard.card.totalTuition': 'Total de Propinas',
  'dashboard.card.receivedToday': 'recebidos hoje',
  'dashboard.card.students': 'Estudantes',
  'dashboard.card.enrollmentsToday': 'inscrições hoje',
  'dashboard.card.totalPayments': 'Total de Pagamentos',
  'dashboard.card.paymentsToday': 'pagamentos hoje',
  'dashboard.card.debts': 'Dívidas',
  'dashboard.card.inDebt': 'em dívida',
  'dashboard.earnings.title': 'Tendência de Pagamentos',
  'dashboard.earnings.period.week': 'Esta Semana',
  'dashboard.earnings.period.month': 'Este Mês',
  'dashboard.earnings.period.year': 'Este Ano',
  'dashboard.earnings.totalPaid': 'Total Pago',
  'dashboard.earnings.totalDebt': 'Total em Dívida',
  'dashboard.earnings.seriesPayments': 'Pagamentos',
  'dashboard.earnings.seriesDebts': 'Dívidas',
  'dashboard.day.sun': 'Dom',
  'dashboard.day.mon': 'Seg',
  'dashboard.day.tue': 'Ter',
  'dashboard.day.wed': 'Qua',
  'dashboard.day.thu': 'Qui',
  'dashboard.day.fri': 'Sex',
  'dashboard.day.sat': 'Sáb',
  'dashboard.month.jan': 'Jan',
  'dashboard.month.feb': 'Fev',
  'dashboard.month.mar': 'Mar',
  'dashboard.month.apr': 'Abr',
  'dashboard.month.may': 'Mai',
  'dashboard.month.jun': 'Jun',
  'dashboard.month.jul': 'Jul',
  'dashboard.month.aug': 'Ago',
  'dashboard.month.sep': 'Set',
  'dashboard.month.oct': 'Out',
  'dashboard.month.nov': 'Nov',
  'dashboard.month.dec': 'Dez',
  'dashboard.recentTransactions.title': 'Últimas Transações',
  'dashboard.recentTransactions.col.student': 'Estudante',
  'dashboard.recentTransactions.col.code': 'Código',
  'dashboard.recentTransactions.col.time': 'Data/Hora',
  'dashboard.recentTransactions.col.amount': 'Valor',
  'dashboard.recentTransactions.empty': 'Sem transações registadas hoje',
  'dashboard.teachers.empty': 'Sem professores registados',
  'dashboard.registrationStatus.title': 'Estado das Inscrições',
  'dashboard.registrationStatus.new': 'Novas Inscrições',
  'dashboard.registrationStatus.unlocked': 'Desbloqueadas',
  'dashboard.registrationStatus.locked': 'Bloqueadas',
  'dashboard.registrationStatus.renew': 'Renovadas',
  'dashboard.registrationStatus.active': 'Activas',
  'dashboard.registrations.empty': 'Sem inscrições registadas',
  'dashboard.registrationsByCourse.title.curso': 'Inscrições por Curso',
  'dashboard.registrationsByCourse.title.classe': 'Inscrições por Classe',
  'dashboard.registrationsByCourse.title.nivel': 'Inscrições por Nível',

  'viewProfile.tab.editProfile': 'Editar Perfil',
  'viewProfile.tab.changePassword': 'Alterar Password',
  'viewProfile.tab.notifications': 'Definições de Notificação',
  'viewProfile.field.name.placeholder': 'Introduza o Nome Completo',
  'viewProfile.field.email.placeholder': 'Introduza o endereço de email',
  'viewProfile.field.contact.placeholder': 'Introduza o número de contacto',
  'viewProfile.password.new': 'Nova Password',
  'viewProfile.password.new.placeholder': 'Introduza a nova password',
  'viewProfile.password.confirm': 'Confirmar Password',
  'viewProfile.password.confirm.placeholder': 'Confirme a nova password',
  'viewProfile.password.validation.required': 'Preencha os dois campos de password',
  'viewProfile.password.validation.mismatch': 'As passwords não coincidem',
  'viewProfile.password.success': 'Password alterada com sucesso',
  'viewProfile.password.error': 'Erro ao alterar a password. Tente novamente.',
  'viewProfile.notifications.companyNews': 'Notícias da Empresa',
  'viewProfile.notifications.pushNotification': 'Notificação Push',
  'viewProfile.notifications.weeklyNewsletters': 'Newsletters Semanais',
  'viewProfile.notifications.meetups': 'Encontros Perto de Si',
  'viewProfile.notifications.orders': 'Notificações de Encomendas',

  // Ecrã de Boas-Vindas — mostrado em vez do Dashboard a perfis sem a
  // permissão 'dashboard.view'.
  'welcome.greeting.morning': 'Bom dia',
  'welcome.greeting.afternoon': 'Boa tarde',
  'welcome.greeting.evening': 'Boa noite',
  'welcome.subtitle': 'É um prazer ter-te por aqui hoje.',
  'welcome.role.label': 'Perfil',
  'welcome.quickAccess.title': 'O que gostarias de fazer?',
  'welcome.quickAccess.subtitle': 'Acesso rápido às funcionalidades disponíveis para o teu perfil.',
  'welcome.quickAccess.empty.title': 'Ainda sem funcionalidades atribuídas',
  'welcome.quickAccess.empty.subtitle': 'Fala com um administrador para obteres acesso às funcionalidades de que precisas.',
  'welcome.footer.tip': 'Dica: podes encontrar tudo o que precisas no menu lateral.',
  'welcome.breadcrumb.title': 'Bem-vindo(a)',
};

export default pt;
